import common from './common'
import featuresPay from './feature'

const tl = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "Produkto/Variants",
        serialNumber: "Serial Number",
        noProductsFound: "Walang nahanap na produkto",
        searchByProductSku: "Maghanap sa produkto/SKU",
        searchSerialNumbers: "Maghanap ng serial numbers",
        transactionDetails: "Detalye ng Transaksyon",
        notAvailable: "N/A",
        mainWarehouse: "Pangunahing Bodega"
    },
    new_build_banner: {
        title: 'Bagong bersyon:',
        is_available: 'ay available na',
        fallback_title: 'May bagong bersyon ng app na available',
        desc: 'Mag-refresh para makuha ang pinakabagong mga feature at pagpapahusay.',
        refreshing: 'Nagre-refresh…',
        refresh_now: 'I-refresh Ngayon',
        later: 'Mamaya na',
        you_are_on: "gamit mo ang"
    },
    short: {
        finance: 'Pinansyal',
        stock: 'Stock'
    },
    onboarding: {
        welcome: 'Maligayang pagdating!',
        step: {
            product: {
                totalBreakdown: 'Kabuuang Breakdown',
                overallFulfilment: 'Pangkalahatang Katuparan',
                totalShippedQty: 'Kabuuang Dami na Naipadala',
                totalReceivedQty: 'Kabuuang Dami na Natanggap',
                totalOrderedQty: 'Kabuuang Dami na Na-order',
                totalShippedOrdered: 'Kabuuang Naipadala / Na-order',
                totalReceivedOrdered: 'Kabuuang Natanggap / Na-order',
                viewQty: 'Tingnan ang Dami',
                fetchingQty: 'Kinukuha ang mga detalye ng dami...',
                noStockInfo: 'Walang nahanap na impormasyon sa stock',
                title: '65% Natapos na',
                description: 'Dalawang hakbang na lang para simulan ang iyong malaking tagumpay!',
                Warehouse: "Bodega",
            },
            stock: {
                title: '95% Halos Tapos na!!',
                description: 'Isang hakbang na lang para simulan ang iyong malaking tagumpay! Tapusin mo na ngayon.'
            }
        },
        business: {
            title: 'Matagumpay na nalikha ang negosyo!',
            description: 'Maganda! Nakarehistro na ang iyong negosyo'
        },
        product: {
            title: 'Magdagdag ng iyong unang produkto',
            description: 'Magdagdag ng produkto para simulan ang pagre-record ng stock',
            Warehouse: "Bodega",
        },
        stock: {
            title: 'Subukang magdagdag ng stock',
            description: 'Simulan ang pagre-record ng papasok at palabas na stock'
        },
        action: {
            add_business: {
                title: 'Gumawa ng Negosyo',
                description: 'Gusto mong gumawa ng bagong negosyo? I-click dito'
            },
            join_business: {
                title: 'Sumali sa Negosyo',
                description: 'May invitation code ka? Sumali dito'
            }
        }
    },
    business: {
        title: 'Pumili ng negosyo, gumawa ng bago, o sumali',
        add_business: {
            title: 'Gumawa ng bagong negosyo',
            name: 'Pangalan ng Negosyo',
            name_placeholder: 'Ilagay ang pangalan',
            category: 'Kategorya ng Negosyo',
            category_placeholder: 'Piliin ang Kategorya',
            button: 'Gumawa ng Negosyo'
        },
        edit_business: {
            title: 'I-edit ang negosyo'
        },
        join_business: {
            title: 'Sumali sa Negosyo',
            input_code: 'Ilagay ang invitation code sa ibaba:',
            field_placeholder: 'Invitation code',
            confirm_title: 'Sumali',
            confirm_text: 'Magiging bahagi ka ng team sa '
        },
        no_business: 'Walang available na negosyo',
        create_or_join: 'Gumawa o sumali sa negosyo',
        message: {
            saved: 'Matagumpay na na-save ang negosyo!'
        },
        settings: {
            isNegativeTransactionDisabled: 'Mga transaksyon ng negatibong stock',
            isNegativeTransactionDisabledHint: 'Sa pag-on nito, maiiwasan mo ang mga transaksyon na magreresulta sa negatibong stock.',
            negativeStockError: 'Ang mga transaksyon ng negatibong stock ay hindi pinagana'
        }
    },
    profile: {
        edit_profile: {
            title: 'I-edit ang profile',
            name: 'Buong Pangalan',
            name_placeholder: 'Ilagay ang buong pangalan',
            email: 'Email',
            phone_number: 'Numero ng Telepono'
        },
        message: {
            required_name: 'Kailangan ang pangalan'
        }
    },
    product: {
        weightedAverageCost: 'Weighted Average Cost',
        weightedAverageValueLabel: 'Weighted Average Value',
        Product: 'Produkto',
        hideZeroStock: 'Itago ang Zero Stock',
        allVariants: 'Lahat ng Variant',
        choose_product: 'Piliin ang Produkto',
        choose_product_empty: 'Piliin ang produkto at ilagay ang dami',
        choose_product_empty_manufacturing: 'Piliin ang produkto at ilagay ang dami ng gagawin',
        search: {
            placeholder: 'Maghanap sa pangalan',
            tooltip: 'Buksan ang scanner',
            Warehouse: "Bodega",
        },
        column: {
            image: 'Larawan',
            name: 'Pangalan',
            price: 'Presyo',
            buying_price: 'Presyong Bumili',
            selling_price: 'Presyong Benta',
            sku: 'SKU',
            stock: 'Stock',
            quantity: 'Dami',
            latest_stock: 'Natitira',
            product_deleted: 'Nabura na ang produkto',
            info_not_found: 'Walang available na impormasyon',
            expired_date: 'Petsa ng Pag-expire',
            invoice: 'Invoice'
        },
        no_product: 'Walang Available na Produkto',
        no_product_subtitle: 'Idagdag ang iyong unang produkto upang simulan ang pagsubaybay sa stock, pagpepresyo, at mga benta.',
        create_first_product: 'Lumikha ng iyong unang produkto',
        add_product: {
            sku: 'Code ng Produkto',
            sku_placeholder: 'Code ng Produkto. Halimbawa: 12345',
            name: 'Pangalan ng Produkto',
            name_placeholder: 'Ilagay ang Pangalan ng Produkto',
            initial_stock: 'Paunang Stock',
            initial_stock_placeholder: 'Ilagay ang Paunang Stock',
            buying_price: 'Presyong Bumili',
            buying_price_placeholder: 'Ilagay ang Presyong Bumili',
            selling_price: 'Presyong Benta',
            selling_price_placeholder: 'Ilagay ang Presyong Benta',
            category: 'Kategorya',
            category_placeholder: 'Piliin ang Kategorya',
            add_selling_price: 'Magdagdag ng Presyong Pakyawan',
            expired_date: 'Petsa ng Pag-expire',
            expired_date_placeholder: 'Piliin ang Petsa',
            description: 'Paglalarawan',
            description_placeholder: 'Ilagay ang Paglalarawan',
            custom_label: 'Attribute',
            custom_label_placeholder: 'Ilagay ang Key',
            add_custom_label: 'Magdagdag ng Higit pang Attribute',
            Warehouse: "Bodega",
        },
        customerLabel: {},
        choose_selling_price: 'Piliin ang Presyong Benta',
        selling_price: 'Presyong Benta',
        total_product: 'Kabuuang Produkto',
        total_quantity: 'Kabuuang Stock',
        total_buying_price: 'Kabuuang Presyong Bumili',
        total_selling_price: 'Kabuuang Presyong Benta',
        message: {
            required_name: 'Kailangan ang pangalan ng produkto',
            required_sku: 'Kailangan ang SKU',
            required_category: 'Kailangan ang kategorya',
            required_quantity: 'Kailangan ang paunang stock',
            invalid_input_qty: 'Hindi wasto ang dami ng stock',
            required_buying_price: 'Kailangan ang presyong bumili',
            required_selling_price: 'Kailangan ang presyong benta',
            required_selling_price_name: 'Kailangan ang pangalan ng presyong benta',
            required_selling_price_price: 'Kailangan ang halaga ng presyong benta'
        },
        viewMore: 'Tingnan Pa',
        WarehouseDetails: 'Detalye ng Warehouse',
        WarehouseName: 'Pangalan ng Warehouse',
        AddWarehouse: 'Magdagdag ng Warehouse',
        WarehouseQty: 'Dami sa Warehouse',
        Warehouse: 'Warehouse',
        Warehouses: 'Mga Warehouse',
        Variants: 'Mga Variant',
        VariantName: 'Pangalan ng Variant',
        productVariant: 'Mga Variant ng Produkto',
        AddVariant: 'Magdagdag ng Mga Variant',
        TranferItem: 'Maglipat ng Item',
        AddUnit: 'Bagong Yunit',
        InitialStkWarehouse: 'Kailangan ng Paunang Stock para magdagdag ng variants',
        InitialStockinwarehouse: 'Paunang Stock sa warehouse',
        TotalQuantity: 'Kabuuang Dami:',
        AddNote: 'Magdagdag ng Tala (Presyong Bumili)',
        AddNotetitle: 'Magdagdag ng Tala',
        VariantSuccessMessage: 'Matagumpay na na-update ang Product Variant',
        Next: 'Susunod',
        Submit: 'Isumite',
        INACTIVE: 'HINDI AKTIBO',
        errorone: 'Oops! Ang hiniling na dami para sa',
        errortwo: "ay hindi tumutugma sa dami sa itinalagang warehouse. Mangyaring i-adjust ang dami o mag-restock.",
        SelectWarehouse: 'Piliin ang Warehouse',
        SelectVariant: 'Piliin ang Variant',
        Discount: 'Diskwento',
        DiscountDetails: 'Detalye ng Diskwento',
        FinalPrice: 'Panghuling Presyo',
        DiscountType: 'Uri ng Diskwento',
        DiscountPer: 'Diskwento %',
        DiscountValue: 'Halaga ng Diskwento',
        Discountonprice: 'Diskwento sa presyo',
        Discountondiscount: 'Diskwento sa diskwento',
        AdditionalDiscount: 'Karagdagang Diskwento',
        SellingPrice: 'Presyong Benta:',
        Save: 'I-save',
        OnOriginalPrice: 'Sa Orihinal na Presyo',
        OnDiscountedPrice: 'Sa May Diskwentong Presyo',
        columnSelector: {
            title: 'Ipakita ang mga Kolum',
            columnsButton: 'Mga Kolum',
            costPrice: 'Presyong Bumili',
            sellingPrice: 'Presyong Ibenta',
            sku: 'SKU',
            warehouse: 'Bodega',
            categories: 'Mga Kategorya',
            safetyStock: 'Safety Stock',
            attributes: 'Mga Katangian',
            notes: 'Mga Tala',
            description: 'Paglalarawan',
            more: 'higit pa',
            attribute: 'Katangian',
            attributesTitle: 'Mga Katangian',
            categoriesTitle: 'Mga Kategorya',
            skuAliases: 'Mga Alias ng SKU'
        }
    },
    note: {
        title: 'Mga Tala',
        add: 'Magdagdag ng Tala',
        no_note: 'Walang available na tala'
    },
    settings: {
        category: 'Kategorya',
        language: 'Wika',
        switch_business: 'Magpalit ng Negosyo',
        currencySelect: 'Pera',
        languageChangeSuccess: 'Matagumpay na Na-update ang Pera',
        languageChangeErrorMessage: 'May Nagkamali habang Ina-update ang Pera',
        currencyAdded: "Matagumpay na naidagdag ang pera",
        currencyDelete: "Matagumpay na natanggal ang pera",
        Selectyourpreferredlanguage: "Piliin ang iyong gustong wika",

    },
    selectProductStock: 'Piliin ang Produkto',
    category: {
        category_list: {
            title: 'Mga Kategorya ng Produkto'
        },
        add_category: {
            button: 'Bagong Kategorya',
            title: 'Magdagdag ng Bagong Kategorya'
        },
        edit_category: {
            title: 'I-edit ang Kategorya'
        },
        name: 'Pangalan ng Kategorya',
        name_placeholder: 'Ilagay ang Pangalan ng Kategorya',
        no_category: 'Walang available na kategorya'
    },
    staff: {
        add: 'Magdagdag ng Staff',
        edit: 'I-edit ang Staff',
        access: {
            stock: 'Stock',
            add_product: 'Magdagdag ng bagong produkto',
            edit_product: 'I-edit ang produkto',
            delete_product: 'Burahin ang produkto',
            view_capital_price: 'Tingnan ang Presyong Bumili',
            add_category: 'Magdagdag ng bagong kategorya',
            edit_category: 'I-edit ang kategorya',
            delete_category: 'Burahin ang kategorya',
            add_supplier: 'Magdagdag ng bagong tagapagbigay (vendor)',
            edit_supplier: 'I-edit ang tagapagbigay',
            delete_supplier: 'Burahin ang tagapagbigay',
            add_customer: 'Magdagdag ng bagong customer',
            edit_customer: 'I-edit ang customer',
            delete_customer: 'Burahin ang customer',
            add_staff: 'Magdagdag ng staff',
            edit_staff: 'I-edit ang staff',
            delete_staff: 'Burahin ang staff',
            change_business_profile: 'Baguhin ang profile ng negosyo',
            access_by_product_category: 'Access ayon sa Kategorya ng Produkto',
            no_category_message: 'Wala kang naidagdag na kategorya. Mangyaring magdagdag ng CategoryList.',
            expenses: 'Mga Gastos',
            view_expenses: 'Tingnan ang Mga Gastos',
            add_expenses: 'Magdagdag ng Gastos',
            edit_expenses: 'I-edit ang Gastos',
            delete_expenses: 'Burahin ang Gastos',
            warehouse: 'Warehouse',
            add_new_warehouse: 'Magdagdag ng Bagong Warehouse',
            edit_warehouse: 'I-edit ang Warehouse',
            delete_warehouse: 'Burahin ang Warehouse',
            transfer_warehouse: 'Maglipat sa Warehouse',
            transfer_warehouse_approval: 'Pag-apruba sa Paglipat ng Warehouse',
            access_by_warehouse: 'Access ayon sa Warehouse',
            no_warehouse_message: 'Wala kang naidagdag na warehouse. Mangyaring magdagdag ng WarehouseList.'
            ,
            notification: 'Notification',
            staffNotification: 'Enable Notification',
            assignee: "Inatasan",
        },
        no_staff: 'Walang available na staff.'
    },
    code: {
        title: 'Matagumpay na Nadagdag ang Bagong Staff!',
        subtitle: 'I-share ang invitation code sa ibaba para sumali:',
        valid: 'Valid lang ang code sa loob ng 48 oras',
        share: 'I-share sa WhatsApp',
        copied: 'Nakopya na!',
        invalid: 'Hindi wasto ang code!'
    },
    history: {
        no_history: 'Walang history.',
        detail: {
            remove: 'Alisin ang History',
            confirm: 'Maaapektuhan nito ang kasalukuyang stock, history, at mga report.'
        },
        no_history_selected: "Walang napiling history",
        select_history_hint: "I-click ang history mula sa listahan upang makita ang mga detalye",
        select_from_left: "Pumili mula sa kaliwang panel",
    },
    supplier: {
        add: {
            title: 'Magdagdag ng Tagapagbigay (Vendor)'
        },
        edit: {
            title: 'I-edit ang Tagapagbigay'
        },
        new: 'Bagong tagapagbigay',
        no_supplier: 'Walang available na tagapagbigay.',
        bank: {
            title: 'Detalye ng Bangko'
        },
        note: 'Mga Tala',
        form: {
            name: {
                label: 'Pangalan ng Tagapagbigay',
                placeholder: 'Ilagay ang Pangalan ng Tagapagbigay',
                placheolder_not_mandatory: 'Ilagay ang pangalan',
                error: {
                    required: 'Hindi maaaring walang laman ang pangalan'
                }
            },
            contact: {
                label: 'Numero ng Contact',
                placeholder: '639123456789',
                error: {
                    required: 'Hindi maaaring walang laman ang numero ng contact',
                    invalid: 'Hindi wasto ang numero. Dapat may country code'
                }
            },
            bank_name: {
                label: 'Pangalan ng Bangko',
                placeholder: 'Ilagay ang Pangalan ng Bangko'
            },
            bank_account_name: {
                label: 'Pangalan ng May-ari ng Account',
                placeholder: 'Ilagay ang Pangalan ng May-ari'
            },
            bank_account_number: {
                label: 'Numero ng Account',
                placeholder: 'Ilagay ang Numero ng Account'
            },
            note: {
                label: 'Mga Tala',
                placeholder: 'Magdagdag ng Mga Tala'
            },
            openingBalance: {
                addBtn: 'Idagdag ang Simulang Balanse',
                label: 'Simulang Balanse',
                placeholder: 'Ilagay ang Simulang Balanse',
                error: {
                    negative: 'Ang simulang balanse ay hindi maaaring maging negatibo'
                }
            }
        },
        choose: 'Piliin ang Tagapagbigay'
    },
    customer: {
        add: {
            title: 'Magdagdag ng Customer'
        },
        edit: {
            title: 'I-edit ang Customer'
        },
        new: 'Bagong customer',
        no_customer: 'Walang available na customer.',
        note: 'Mga Tala',
        form: {
            name: {
                label: 'Pangalan ng Customer',
                placeholder: 'Ilagay ang Pangalan ng Customer',
                placheolder_not_mandatory: 'Ilagay ang pangalan',
                error: {
                    required: 'Hindi maaaring walang laman ang pangalan'
                }
            },
            contact: {
                label: 'Numero ng Contact',
                placeholder: '639123456789',
                error: {
                    required: 'Hindi maaaring walang laman ang numero ng contact',
                    invalid: 'Hindi wasto ang numero. Dapat may country code'
                }
            },
            address: {
                label: 'Address',
                placeholder: 'Ilagay ang Address'
            },
            note: {
                label: 'Mga Tala',
                placeholder: 'Magdagdag ng Mga Tala'
            },
            openingBalance: {
                addBtn: 'Idagdag ang Simulang Balanse',
                label: 'Simulang Balanse',
                placeholder: 'Ilagay ang Simulang Balanse',
                error: {
                    negative: 'Ang simulang balanse ay hindi maaaring maging negatibo'
                }
            }
        },
        choose: "Pumili ng Customer",
        report: {
            view: 'Tingnan ang Report ng Mamimili',
            title: 'Report ng Customer',
            no_report: 'Walang report para sa mga mamimili sa napiling petsa.',
            column: {
                name: 'Pangalan',
                total_transaction: 'Kabuuang Transaksyon',
                total_amount: 'Kabuuang Benta',
                total_profit: 'Kabuuang Kita'
            }
        }
    },
    confirm_delete: 'Sigurado ka bang gusto mong burahin ang datang ito?',
    report: {
        title: 'Report'
    },
    accounting: {
        download_pdf_report: 'I-download ang PDF',
        title: 'Accounting',
        view_report: 'Tingnan ang Financial Report',
        dashboard_title: 'Financial Report',
        stats: 'Mga Estadistika',
        accounting_report: 'Report ng Accounting',
        filter: {
            date: {
                placeholder: 'Piliin ang Petsa',
                submit: 'Ilapat',
                cancel: 'I-reset ang Filter'
            },
            timeframe: {
                day: 'Araw-araw',
                week: 'Lingguhan',
                month: 'Buwan-buwan',
                year: 'Taun-taon'
            }
        },
        total_sales: 'Kabuuang Benta',
        total_purchases: 'Kabuuang Binili',
        total_profit: 'Kabuuang Kita',
        total_expenses: 'Kabuuang Gastos',
        assets_value: 'Kasalukuyang Halaga ng Asset',
        total_current_cogs_value: 'Kabuuang Kasalukuyang Halaga ng COGS',
        current_asset_selling_price: 'Kasalukuyang Presyo ng Pagbebenta ng Asset',
        total_selling_price: 'Kabuuang Presyo ng Pagbebenta',
        table: {
            date: 'Petsa',
            sales: 'Benta',
            purchases: 'Binili',
            profit: 'Kita',
            expenses: 'Gastos'
        },
        no_data: 'Walang available na data.'
    },
    stock_report: {
        title: 'Stock Report',
        view: 'Tingnan ang Stock Report',
        no_report: 'Walang tala ng stock para sa napiling petsa o staff.',
        allStaffPlaceHolder: 'Lahat ng Staff',
        column: {
            total_product: 'Kasalukuyang Uri ng Produkto',
            total_product_quantity: 'Kabuuang Kasalukuyang Produkto'
        }
    },
    subscription: {
        paywall_small: {
            title: 'VIP Feature',
            description:
                'Tapos na ang trial period mo para sa feature na ito. Suportahan ang pag-unlad ng lokal na app na ito sa pamamagitan ng pag-subscribe.',
            button: 'Tingnan ang Mga Plano sa Subscription'
        }
    },
    payment: {
        order: {
            title: 'Bayad'
        }
    },
    imageUploadMessage: {
        uploadSize: 'Ang laki ng larawan ay hindi dapat lalampas sa 5MB!',
        failedMessage: 'Nabigo sa pag-upload ng larawan ng item, pakisubukan ulit!',
        successUpload: 'Matagumpay na na-upload ang larawan!',
        failedUIError: 'Nabigo sa pagbura ng larawan, pakisubukan ulit!',
        SuccessErrorImage: 'Matagumpay na nabura ang larawan!'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'Pangalan ng Produkto',
        categoryLabel: 'Kategorya',
        BuyingPriceLabel: 'Presyong Bumili',
        SellingLabel: 'Presyong Benta',
        StockLabel: 'Stock'
    },
    historyColumns: {
        Transactionlabel: 'Uri ng Transaksyon',
        Locallabel: 'Oras ng Lokal',
        Createdlabel: 'Ginawa ni',
        Vendorlabel: 'Pangalan ng Tagapagbigay',
        Buyerlabel: 'Pangalan ng Mamimili',
        SKUlabel: 'SKU',
        Invoicelabel: 'Invoice',
        Productlabel: 'Pangalan ng Produkto',
        Categorylabel: 'Kategorya',
        Buyinglabel: 'Presyong Bumili',
        Sellinglabel: 'Presyong Benta',
        Initiallabel: 'Paunang Stock',
        Finallabel: 'Panghuling Stock',
        Stocklabel: 'Pagbabago sa Stock'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'Pangalan ng Produkto',
        categoryLabel: 'Kategorya',
        buyingPriceLabel: 'Presyong Bumili',
        sellingPriceLabel: 'Presyong Benta',
        stockInLabel: 'Stock In',
        stockOutLabel: 'Stock Out',
        remainingStockLabel: 'Natitirang Stock',
        openStockLabel: 'Paunang Stock',
        weightedAverageCost: 'Weighted Average Cost',
        weightedAverageCostLabel: 'Weighted Average Cost',
        weightedAverageValueLabel: 'Weighted Average Value'
    },
    accountingReportColumns: {
        dateRange: 'Saklaw ng petsa',
        reportingPeriod: 'Panahon ng Pag-uulat',
        reportGenerate: 'Binuong Ulat',
        warehouse: 'Bodega',
        labelDate: 'Petsa',
        labelSales: 'Benta',
        labelPurchases: 'Binili',
        labelProfit: 'Kita',
        labelExpenses: 'Mga Gastusin',
        reportOptions: 'Mga Kolum ng Ulat',
        summaryCards: 'Mga Summary Card',
        grandTotal: 'Pangkalahatang Kabuuan',
        continued: 'tuloy',
        subtotal: 'Subtotal',
        page: 'Pahina'
    },
    customerReportColumns: {
        labelName: 'Pangalan',
        labelTotalTransaction: 'Kabuuang Transaksyon',
        labelTotalSales: 'Kabuuang Benta',
        labelTotalProfit: 'Kabuuang Kita'
    },
    scannerDialog: {
        finished: 'Tapos Na',
        reduce: 'Bawasan',
        successfull: 'Matagumpay',
        searching: 'Naghahanap...',
        title: 'Aktibo ang scanner. Ituro sa barcode!'
    },
    historyFilter: {
        SelectBuyer: 'Piliin ang Mamimili',
        SelectVendor: 'Piliin ang Tagapagbigay'
    },
    productStockFilter: {
        StockLowtoHigh: 'Stock Mababa hanggang Mataas',
        StockHightoLow: 'Stock Mataas hanggang Mababa',
        AlphabetAZ: 'Alpabetong A-Z',
        AlphabetZA: 'Alpabetong Z-A'
    },
    minimizeTitle: 'Aktibo ang Scanner',
    security_guarantee: {
        title: 'Garantisadong Seguridad ng Data'
    },
    invoice: {
        invoicePlaceholder: 'Numero ng Invoice',
        invoiceTitle: 'Invoice',
        manageInvoiceAddress: 'Pamahalaan ang Invoice Address',
        selectOrManageAddresses: 'Pumili, mag-edit, o lumikha ng mga custom na invoice address',
        useBusinessProfileAddress: 'Gumamit ng Business Profile Address',
        noCustomAddressesFound: 'Walang Custom na Address na Idinagdag',
        createCustomAddressDesc: 'Magdagdag ng mga custom na billing o branch address para i-print sa iyong mga invoice sa halip na default na data ng business profile.',
        defaultFromBusinessProfile: 'Default Mula sa Business Profile',
        editInvoiceAddress: 'I-edit ang Invoice Address',
        createNewInvoiceAddress: 'Lumikha ng Bagong Invoice Address',
        logoHeaderImage: 'Logo / Header Image',
        deleteInvoiceAddress: 'Burahin ang Invoice Address?',
        deleteAddressConfirmText: 'Sigurado ka bang gusto mong burahin ang invoice address na ito? Hindi na mababago ang aksyong ito.'
    },
    ManageInvoiceAddress: 'Pamahalaan ang Invoice Address',
    SelectOrManageAddresses: 'Pumili, mag-edit, o lumikha ng mga custom na invoice address',
    UseBusinessProfileAddress: 'Gumamit ng Business Profile Address',
    CreateNewAddress: 'Lumikha ng Bagong Address',
    UpdatingList: 'Ina-update ang listahan...',
    NoCustomAddressesFound: 'Walang Custom na Address na Idinagdag',
    CreateCustomAddressDesc: 'Magdagdag ng mga custom na billing o branch address para i-print sa iyong mga invoice sa halip na default na data ng business profile.',
    DefaultFromBusinessProfile: 'Default Mula sa Business Profile',
    EditInvoiceAddress: 'I-edit ang Invoice Address',
    CreateNewInvoiceAddress: 'Lumikha ng Bagong Invoice Address',
    LogoHeaderImage: 'Logo / Header Image',
    UploadingImage: 'Ina-upload ang Imahe...',
    UploadImage: 'Mag-upload ng Imahe',
    BusinessName: 'Pangalan ng Negosyo',
    AddressDetails: 'Mga Detalye ng Address',
    PhoneNumber: 'Numero ng Telepono',
    EmailAddress: 'Email Address',
    DeleteInvoiceAddress: 'Burahin ang Invoice Address?',
    DeleteAddressConfirmText: 'Sigurado ka bang gusto mong burahin ang invoice address na ito? Hindi na mababago ang aksyong ito.',

    stocklowreport: {
        no_stocklowreport_one: 'Walang item na may nakatakdang Safety Stock.',
        no_stocklowreport_two: 'Mangyaring magdagdag ng dami ng Safety Stock.',
        currentStock: 'Kasalukuyang Stock',
        safetyStock: 'Safety Stock',
        pricing: 'Pagpepresyo',
        costPrice: 'Presyo ng Gastos',
        sellingPrice: 'Presyo ng Pagbebenta',
        productInfo: 'Impormasyon ng Produkto',
        category: 'Kategorya',
        description: 'Paglalarawan',
        no_description: 'Walang idinagdag na paglalarawan',
        variants: 'Mga Variant',
        unitsOnHand: 'mga yunit na nasa stock',
        minimumThreshold: 'minimum na limitasyon',
        adjust: 'Ayusin',
        all: 'Lahat',
        lowStock: 'Mababang Stock',
        variantsDetails: 'Mga Detalye ng Variant',
        qty: 'Dami',
        addSafetyStock: 'Magdagdag ng Safety Stock',
        searchByNameSku: 'Maghanap ayon sa pangalan/SKU',
        safetyStockShort: 'S',
        warehouseSafetyStock: 'Safety Stock ng Warehouse'
    },
    low_alert_stock: 'Ilagay ang dami ng safety stock',
    lowStockAlertNotify: "Makakatanggap ka ng notification kapag bumaba ang stock sa ibaba ng itinakdang dami",
    applyButtonStockAlert: 'Ilapat',
    cancelButtonStockAlert: 'Kanselahin',
    searchProductLabel: 'Maghanap ng mga produkto...',
    successfullyAddedSafetyStock: 'Matagumpay na na-update ang Safety Stock',
    safety_Stock: 'Safety Stock',
    safety_stock_placeholder: 'Ilagay ang Safety Stock',
    lowStockDetailsInfo: {
        ProductCode: 'Code ng Produkto',
        SafetyStock: 'Safety Stock',
        Stock: 'Stock',
        CostPrice: 'Presyong Bumili',
        SellingPrice: 'Presyong Benta',
        Category: 'Kategorya',
        Description: 'Paglalarawan',
        ExpirationDate: 'Petsa ng Pag-expire'
    },
    CustomLang: {
        Attribute: 'Attribute',
        AddAttribute: 'Magdagdag ng Attribute',
        EditAttribute: 'I-edit ang Attribute',
        CustomLabePlaceholder: 'Ilagay ang Pangalan ng Attribute',
        CustomLabePlaceholderSelect: 'Piliin ang Uri',
        AddMoreAttribute: 'Magdagdag ng Higit pang Attribute',
        ItemAttribute: 'Attribute ng Item',
        TableName: 'Pangalan',
        TableType: 'Uri',
        TableAction: 'Aksyon',
        TableDelete: 'Burahin',
        TableEdit: 'I-edit',
        deleteMessage: 'Matagumpay na Nabura ang Attribute',
        editSuccessMessage: 'Matagumpay na Na-update ang Attribute',
        AddSuccessMessage: 'Matagumpay na Nadagdag ang Attribute',
        AddAtt: 'Magdagdag',
        EditAtt: 'I-edit',
        SubmitAtt: 'Isinusumite...'
    },
    Expenses: {
        ExpensesTitle: 'Mga Gastos',
        AddExpenses: 'Magdagdag ng Gastos',
        ExpenseCategory: 'Kategorya ng Gastos',
        NoExpenseCategory: 'Walang kategorya ng gastos',
        AddExpenseCategory: 'Magdagdag ng kategorya ng gastos',
        SelectExpenseCategory: 'Piliin ang kategorya ng gastos',
        NoExpenses: 'Walang Gastos',
        ExpensesSuccess: 'Matagumpay na nalikha ang gastos',
        ExpensesSuccessEdit: 'Matagumpay na na-update ang gastos',
        ExpensesCategoryName: 'Pangalan ng kategorya ng gastos',
        ExpensesSuccessDelete: 'Matagumpay na nabura ang gastos',
        AddNEC: 'Magdagdag ng Bagong Kategorya ng Gastos',
        NC: 'Bagong Kategorya ng Gastos',
        EditNEC: 'I-edit ang Kategorya ng Gastos'
    },
    Manufacturing: {
        ProducedProduct: "Nagawa na Produkto",
        QuantityManufactured: "Dami ng Ginawa",
        UnitCost: "Halaga Bawat Yunit",
        RawMaterialsTotal: "Kabuuan ng Hilaw na Materyales",
        TotalManufacturingCost: "Kabuuan ng Halaga ng Pagmamanupaktura",
        NoRawMaterialsConsumed: "Walang nakonsumang hilaw na materyales.",
        CostBreakdown: "Paghahati-hati ng Gastos",
        GeneratedBatch: "Nagawa na Batch",
        StoredBinLocation: "Lokasyon ng Imbak",
        NoManufacturingTransactionsFound: "Walang nahanap na transaksyon ng pagmamanupaktura",
        AddManufacture: 'Magdagdag ng Detalye ng Paggawa',
        Manufacturing: 'Paggawa',
        RawMaterials: 'Raw',
        AdditonCosts: 'Karagdagang Gastos',
        RawMaterial: 'Raw Material',
        AdditonCost: 'Karagdagang Gastos',
        TotalCost: 'Kabuuang Gastos',
        AddRawMaterial: 'Magdagdag ng raw material para sa',
        AddAdditonCost: 'Magdagdag ng karagdagang gastos para sa',
        AddMore: 'Magdagdag pa',
        Add: 'Magdagdag',
        Update: 'I-update',
        Updating: 'Isinusumite...',
        ProductRequired: 'Kailangan ang produkto',
        QuantityRequired: 'Kailangan ang dami',
        ChargeRequired: 'Kailangan ang bayad',
        EstimatedCostRequired: 'Kailangan ang tinatayang gastos',
        PurchasePriceRequired: 'Kailangan ang presyo ng pagbili',
        SelectCharge: 'Piliin ang Bayad',
        EstimatedCost: 'Tinatayang Gastos',
        SelectProduct: 'Piliin ang Produkto',
        Quantity: 'Dami',
        ManufactureDetails: 'Detalye ng Paggawa',
        BuyingPrice: 'Presyong Bumili',
        LabourCharge: 'Bayad sa Paggawa',
        ElectricityCost: 'Gastos sa Kuryente',
        PackagingCharge: 'Bayad sa Packaging',
        LogisticCost: 'Gastos sa Logistics',
        OtherCharges: 'Iba pang Bayad',
        Save: 'I-save ang detalye',
        PurchasePrice: 'Presyo ng Pagbili',
        Date: 'Petsa',
        For: 'Para sa',
        PurchaseRate: 'Purchase Rate (Presyo)',
        Scrolltoloadmore: 'Mag-scroll para mag-load ng higit pa...',
        Noproductsfound: 'Walang nakitang produkto',
        ManufacturingQuantity: 'Dami ng Paggawa',
        ManufactureAddedSuccess: 'Matagumpay na na-update ang detalye ng paggawa'
    },
    Warehouses: {
        transferOrder: 'Maglipat ng Items',
        AddTransferOrder: 'Magdagdag ng Transfer Items',
        NewWarehouse: 'Bagong Warehouse',
        newHead: 'Simulan ang pamamahala ng maraming warehouse!',
        headTwo: 'Madaling subaybayan at pamahalaan ang iyong inventory sa iba’t ibang warehouse',
        EnableWarehouse: 'I-enable ang Warehouse',
        EnableWarehouse2: 'I-enable ang Warehouse',
        OrganizationPrimary: "Pangunahin ng Organisasyon",
        Edit: 'I-edit',
        AreEnableWarehouse: 'Sigurado ka bang gusto mong i-enable ang warehouse?',
        Confirm: 'Kumpirmahin',
        Cancel: 'Kanselahin',
        WarehouseCreatedSuccessfully: 'Matagumpay na nalikha ang warehouse',
        MarkAsOP: "Itakda bilang Pangunahin ng Organisasyon",
        MarkAsInAct: 'Itakda bilang Hindi Aktibo',
        MarkAsAct: 'Itakda bilang Aktibo',
        MarkedAsInactive: 'Matagumpay na naitakda bilang hindi aktibo ang warehouse',
        MarkedAsActive: 'Matagumpay na naitakda bilang aktibo ang warehouse',
        MarkedAsOP: 'Matagumpay na naitakda bilang aktibo ang warehouse',
        WareDeletedSuccess: 'Matagumpay na nabura ang warehouse',
        SuccessfullyUpdatedWarehouse: 'Matagumpay na na-update ang warehouse',
        SuccessfullyCreatedWarehouse: 'Matagumpay na nalikha ang warehouse',
        EditWarehouse: 'I-edit ang Warehouse',
        AddWarehouse: 'Magdagdag ng Warehouse',
        WarehouseNameIsRequired: 'Kailangan ang pangalan ng warehouse',
        EnterWarehouseName: 'Ilagay ang pangalan ng warehouse',
        EnterEmail: 'Ilagay ang email',
        EnterPhoneNumber: 'Ilagay ang numero ng telepono',
        Location: 'Lokasyon...',
        name: 'Pangalan ng Warehouse',
        email: 'Email',
        phoneNumber: 'Numero ng Telepono',
        location: 'Lokasyon',
        ViewProducts: 'Tingnan ang Mga Produkto',
        PageTitle: 'Warehouse',
        noWarehouse: "Walang warehouse na tumutugma sa iyong paghahanap"
    },
    Assets: {
        headerTitle: 'Mga Ari-arian',
        addAssetMessage: "Magdagdag ng mga ari-arian dito. Upang magtalaga ng asset sa staff, pumunta sa profile ng staff member.",
        addAsset: 'Magdagdag ng Asset',
        editAsset: 'I-edit ang Asset',
        assetCode: 'Code ng Asset',
        assetName: 'Pangalan ng Asset',
        assetCategory: 'Kategorya ng Asset',
        assetType: 'Uri ng Asset',
        serialNumber: 'Serial Number',
        location: 'Lokasyon',
        condition: 'Kondisyon',
        selectCondition: 'Piliin ang Kondisyon',
        fair: 'Katamtaman',
        good: 'Mabuti',
        excellent: 'Mahusay',
        poor: 'Mahina',
        notes: 'Mga Tala',
        submit: 'Isumite',
        submitting: 'Isinusumite',
        noCategory: 'Walang kategorya',
        selectCategory: 'Piliin ang kategorya',
        addAssetCat: 'Magdagdag ng Kategorya ng Asset',
        addAssetCatName: 'Pangalan ng kategorya ng asset',
        edit: 'I-edit',
        status: 'Katayuan',
        createdAt: 'Nilikha Noong',
        viewAsset: 'Tingnan ang Asset',
        assignAsset: 'Magtalaga ng Asset',
        conditionRet: 'Kondisyon (Sa pagbabalik)',
        searchSelectAssets: 'Maghanap/Pumili ng Asset',
        assetAssigned: 'Matagumpay na natatalaga ang asset',
        assetReturned: 'Matagumpay na naibalik ang asset',
        selectAnAsset: 'Mangyaring pumili ng asset',
        action: 'Aksyon',
        noAssetAssigned: 'Walang natatalagang asset',
        reAssigned: 'Muling italaga',
        assignedAssetsList: 'Listahan ng Mga Natatalagang Asset',
        viewHistory: 'Tingnan ang Kasaysayan',
        history: 'Kasaysayan ng Asset',
        loadingHistory: 'Naglo-load ng kasaysayan...',
        loadingMore: 'Naglo-load pa...',
        dateTime: 'Petsa at Oras',
        staff: 'Staff',
        AssignedBy: 'Itinalaga ni',
        assign: 'ITALAGA',
        return: 'IBALIK',
        unknown: 'HINDI ALAM',
        noHistory: 'Walang kasaysayan para sa asset na ito.',
        enterReturnNote: 'Ilagay ang tala para sa pagbabalik',
        returnNote: 'Tala sa Pagbabalik',
        enterAssignNote: 'Ilagay ang tala para sa pagtatalaga',
        assignNote: 'Tala sa Pagtatalaga',
        AddNAC: "Magdagdag ng Bagong Kategorya ng Asset",
        EditNAC: "I-edit ang Kategorya ng Asset",
        others: "Iba pa"
    },
    LedgerTransaction: {
        ledgerDetails: 'Detalye ng Ledger',
        productName: 'Pangalan ng Produkto',
        totalQty: 'Kabuuang Dami',
        date: 'Petsa',
        receivedAmt: 'Natanggap na Halaga',
        paid: 'Binayaran',
        discount: 'Diskwento',
        balance: 'Balanse',
        more: 'higit pa',
        total: 'Kabuuan',
        ledgerupdatedsuccessfully: 'Matagumpay na na-update ang ledger',
        ledgeraddedsuccessfully: 'Matagumpay na nadagdag ang ledger',
        viewLedger: 'Tingnan ang Ledger',
        edit: 'I-edit',
        create: 'Gumawa',
        Recieved: 'Natanggap [stock in]',
        payMode: 'Paraan ng Bayad',
        Refno: 'Ref no'
    },
    ExtraField: {
        attachment: 'Attachment',
        acceptOnlyImg: 'Mga larawan lang ang tinatanggap.',
        addAttribute: 'Magdagdag ng Attribute',
        acceptImgAndDoc: 'Tinatanggap ang mga larawan at dokumento.'
    },
    phoneInvoiceDownload: {
        Variant: 'Variant',
        Warehouse: 'Warehouse',
        Bin: 'Bin',
        Batch: 'Batch',
        Attributes: 'Mga Attribute'
    },
    ImportExcel: {
        ImportStockfromExcel: "Mag-import ng Stock mula sa Excel",
        DragDrop: "I-drag & i-drop ang iyong napunong Excel file dito, o i-click para mag-browse",
        DT: "I-download ang Template",
        GB: "Bumalik",
        Downloading: "Nagda-download...",
        ChangeFile: "Baguhin ang File",
        ReadingExcelfile: "Binabasa ang Excel file...",
        Processing: "Pinoproseso...",
        submitUpdateStock: "Isumite at I-update ang Stock",
        downloadLatestTemplate: "I-download ang Pinakabagong Template",
        loginRequired: "Kailangan ang Login"
    },
    stockForm: {
        recordPaymentNow: "Itala ang bayad ngayon",
        recordPaymentDescCustomer: "Ilagay ang halagang binayaran ng customer",
        recordPaymentDescSupplier: "Ilagay ang halagang binayaran ng supplier",
        managePayments: "Pamahalaan ang Mga Bayad",
        invoice: "Invoice",
        challan: "Challan",
        recordPayment: "I-record ang Bayad",
        payableAmount: "Dapat Bayaran",
        paidAmount: "Binayarang Halaga",
        paymentMethod: "Paraan ng Bayad",
        paymentDate: "Petsa ng Bayad",
        reference: "Reperensya",
        billId: "Numero ng Bill",
        importExcel: "Mag-import mula sa Excel",
        noThanks: "Hindi, Salamat",
        checkHistory: "Suriin ang Iyong Kasaysayan",
        wantViewHistory: "Gusto mo bang tingnan ang iyong kasaysayan?",
        enterPayable: 'Ilagay ang Dapat Bayaran',
        enterPaid: 'Ilagay ang Binayarang Halaga',
        selectPayment: "Piliin ang Paraan ng Bayad",
        attachment: "Attachment",
        note: "Tala"
    },
    HistoryEdit: {
        products: "Mga Produkto",
        add_product: "Magdagdag ng Produkto",
        paidAmountInvalidMessage: 'Ang binayarang halaga ay hindi maaaring mas mataas sa dapat bayaran',
        removingText: "Ang pag-alis ng produktong ito ay ibabalik ang mga pagbabago sa stock na ginawa sa transaksyong ito.",
        remove: "Alisin",
    },
    ExcelProduct: {
        uploadFile: "Mag-upload ng File",
        dragDrop: "I-drag at i-drop ang iyong Excel file, o i-click para mag-upload.",
        parsingFile: "Pinoproseso ang file",
        fileSelected: "Napiling file",
        reviewImportedData: "Suriin ang na-import na data sa ibaba. Awtomatikong na-match ang mga column kung posible.",
        changeFile: "Baguhin ang File",
        back: "Bumalik",
        invalidFileType: "Mangyaring mag-upload ng wastong Excel file (.xlsx o .xls)",
        parseExcelError: "Error sa pag-parse ng Excel:",
        noData: "Walang data ang na-upload na Excel file.",
        failedToRead: "Nabigo sa pagbasa ng Excel file. Pakisubukan ulit.",
        Nodata: "WALANG_DATA",
        unableToRead: "Hindi mabasa ang file.",
        buyingMustNumber: "Ang Presyong Bumili ay dapat numero",
        sellingMustNumber: "Ang Presyong Benta ay dapat numero",
        mustBeNumber: "dapat numero",
        bulkUploadfailed: "Nabigo ang bulk upload",
        importFromExcel: "Mag-import mula sa Excel",
        generating: "Gumagawa...",
        downloadTemplate: "I-download ang Template",
        uploading: "Nag-u-upload...",
        done: "Tapos Na",
        requiredField: "{field} ay kailangan",
        bulkUpload: "Bulk Upload",
        duplicateSku: "May nakitang dobleng SKU",
        uploadedSuccessfully: "Matagumpay na na-upload ang lahat ng produkto!",
        uploadCompleteIssues: "Natapos ang upload na may mga isyu",
        uploaded_products: "Na-upload ang {count} produkto.",
        failed_products: "{count} ang nabigo.",
        failed_items: "Nabigong item:"
    },
    ProductForm: {
        barcodeQuantity: "Ilagay ang Dami ng Barcode",
        baseUnit: "Base Unit (Pangunahin)",
        addSecondaryUnit: "Magdagdag ng Secondary Unit?",
        selectUnit: "Piliin ang Unit",
        subUnitDetails: "Detalye ng Sub Unit",
        subUnit: "Sub Unit",
        selectSubUnit: "Piliin ang Sub Unit",
        conversionRate: "Conversion Rate",
        exampleLogic: "Halimbawa ng lohika:",
        example: "Kung nagbebenta ka ng ballpen sa kahon, itakda ang Base Unit bilang Box at magdagdag ng Sub Unit na pcs na may conversion na 50. Ibig sabihin, 1 Box = 50 piraso.",
        basePrice: "Base Price",
    },
    barcode: {
        settings: 'Mga Setting ng Barcode',
        labelSize: 'Laki ng label',
        customSize: 'Custom na laki...',
        widthMm: 'Lapad (mm)',
        heightMm: 'Taas (mm)',
        showPrice: 'Ipakita ang presyo ng benta sa label',
        noPrices: 'Walang mga presyo ng benta na naka-configure para sa produktong ito.',
        preview: 'Preview',
        generate: 'I-generate',
        label: 'label',
        singlePage: 'Single Page',
        downloadOptions: 'Mga Opsyon sa Pag-download',
        chooseLayout: 'Pumili ng layout para sa mga barcode',
        allInSinglePage: 'Idagdag ang lahat ng barcode sa isang pahina.',
        allInA4Grid: 'Lahat sa Single Page',
        allInA4GridSub: 'Inilalagay ang lahat ng barcode sa isang A4 grid',
        onePerPage: 'Isa Bawat Pahina',
        onePerPageSub: 'Bawat barcode sa sariling pahina ng label'
    },

    Discount: {
        overallDiscount: "Kabuuang Diskwento",
        final: 'Panghuli',
        balanceDue: "Natitirang Babayaran",
        tax: "Buwis",
    },
    TransferItem: {
        transferItem: 'Maglipat ng Items',
        Date: 'Petsa',
        Reason: 'Dahilan',
        enterReason: "Ilagay ang Dahilan",
        Name: 'Pangalan',
        QuantityTransfered: 'Dami na Nailipat',
        SWarehouse: 'Pinagmulang Warehouse',
        SelectSWarehouse: 'Piliin ang Pinagmulang Warehouse',
        DWarehouse: 'Patutunguhang Warehouse',
        SelectDWarehouse: 'Piliin ang Patutunguhang Warehouse',
        CreatedBy: 'Ginawa ni',
        CreatedTime: 'Oras ng Paglikha',
        UpdatedTime: 'Oras ng Pag-update',
        NoOrderFound: 'Walang Natagpuang Order',
        New: 'Bago',
        WarehouseItemTransfer: 'Paglilipat ng Items sa Warehouse',
        TotalTransfers: "Kabuuang Paglilipat",
        EnterReason: 'Ilagay ang Dahilan',
        ItemDetails: 'Detalye ng Item',
        CurrentAvailable: 'Kasalukuyang Available',
        TransferQty: 'Dami na Ililipat',
        SStock: 'Stock sa Pinagmulan',
        DStock: 'Stock sa Patutunguhan',
        addDescription: "Magdagdag ng paglalarawan sa iyong item",
        selectVariant: "Piliin ang variant",
        addNewRow: "Magdagdag ng bagong row",
        typeOrSelectItem: "Mag-type para maghanap",
        scrollToLoadMore: "Mag-scroll para mag-load ng higit pa",
        noProductsFound: "Walang nakitang produkto",
        selectWarehouse: "Piliin ang warehouse"
    },
    Sku: {
        searchSelectProduct: "Maghanap/Pumili ng Produkto",
        searchSelectSku: "Maghanap/Pumili ng SKU",
        noSkuFound: "Walang nakitang SKU"
    },
    HistoryPage: {
        addFilter: "Magdagdag ng Filter",
        filtersActive: "Lahat ng filter ay aktibo",
        noProducts: "Walang produkto",
        download: "I-download",
        recentlyUpdated: "Kamakailang Na-update",
    },
    StockPage: {
        challanNumber: "Numero ng Challan",
        subTotal: "Sub Total",
        totalTaxes: "Kabuuan at Buwis",
        taxInclusive: "Kasama ang Buwis",
        discountedValue: "May Diskwentong Halaga",
        taxValue: "Halaga ng Buwis",
        totalAmount: "Kabuuang Halaga",
        close: "Isara",
        addTax: "Magdagdag ng Buwis",
        label: "Label",
        enterLabel: "Ilagay ang Label",
        taxRate: "Tax Rate",
        enterTaxRate: "Ilagay ang tax rate",
        selectTaxRate: "Piliin ang tax rate",
        addNewTax: "Magdagdag ng bagong tax rate",
        discountProducts: "May Diskwentong Halaga (Mga Produkto)",
        taxProducts: "Halaga ng Buwis (Mga Produkto)",
        clickAddPayment: "I-click para magdagdag ng bayad",
        paidGreaterPayable: "Ang binayarang halaga ay hindi maaaring mas mataas sa dapat bayaran",
        vendorCompulsory: 'Kailangan ang Vendor para mag-record ng bayad',
        customerCompulsory: "Kailangan ang customer upang maitala ang bayad",
        updateInvoiceFormat: "I-update ang Format ng Invoice",
        updateChallanFormat: "I-update ang Format ng Challan",
        addPrefix: "Magdagdag ng Prefix",
        prefix: "Prefix"
    },
    EditHistoryPage: {
        search_by_notes: "Maghanap ayon sa Mga Tala",
        alertMessage: "Ang pagbabagong ito ay naitala lamang sa history at hindi naaapektuhan ang kasalukuyang stock ng produkto.",
        paymentDetails: "Detalye ng Bayad",
        units: "Mga Yunit",
        customLabels: "Custom Labels",
        value: "Halaga",
        Order_Info: "Impormasyon ng Order",
        percentage: "Porsyento",
        Stock_updates_on_submit: "I-update ang stock kapag isinumite",
        Summary: "Buod"

    },
    historyCard: {
        paid: "BINAYARAN",
        partiallyPaid: "BAHAGYANG BINAYARAN",
        billDate: "Petsa ng Bill",
        productDetails: "Detalye ng Produkto",
        paymentsHistory: "Kasaysayan ng Bayad",
        updatePayment: "I-update ang Bayad",
        discounts: "Mga Diskwento",
        inclusive: "(kasama)",
        discountOverall: "May Diskwentong Halaga (Kabuuang)",
        dueAmount: "Natitirang Dapat Bayaran",
        enterPaid: "Ilagay ang Binayarang Halaga",
        enterReference: "Ilagay ang Reperensya",
        enterNote: "Ilagay ang Tala",
        enterInvoice: "Ilagay ang Invoice",
        enterChallan: "Ilagay ang Challan",
        edit: "Na-edit"
    },
    printInvoice: {
        billTo: "Bill To",
        ref: "Ref No.",
        mode: "Paraan",
        date: "Petsa",
        amount: "Halaga",
        totalPaid: "Kabuuang Binayaran",
        noImage: "Walang Larawan"
    },
    Contact: {
        supplier_required: "Kailangan ang Supplier para sa stock in",
        customer_required: "Kailangan ang Customer para sa stock out",
        key: "Key",
        editHistory: "I-edit ang History",
        loading: "Naglo-load..."
    },
    AW: {
        availablewarehouse: "Available na Warehouse",
        visibilityManagement: 'Pamamahala ng Visibility',
        availablewarehouses: "Mga Available na Warehouse",
        Active: "Aktibo",
        LWarehouse: "Naglo-load ng Mga Warehouse...",
        NWForthisProduct: "Walang warehouse na natagpuan para sa produktong ito.",
        of: "ng",
        WarehouseAvailabilty: "Availability ng Warehouse",
    },
    Currency: {
        searchCurrency: "Maghanap ng Pera...",
        addCurrency: "Magdagdag ng Pera",
        addNewCurrency: "Magdagdag ng Bagong Pera",
        editCurrency: "I-edit ang Pera",
        currencySymbol: "Simbolo ng Pera",
        currencyName: "Pangalan ng Pera",
        enterCurrencySymbol: "Ilagay ang Simbolo ng Pera",
        enterCurrencyName: "Ilagay ang Pangalan ng Pera"
    },
    NewReportLang: {
        DM: "Araw-araw na Paggalaw",
        WR: "Ulat ng Bodega",
        PDM: "Araw-araw na Paggalaw ng Produkto",
        TBP: "Kabuuang Presyo ng Pagbili",
        TPQ: "Kabuuang Dami ng Produkto",
        TP: "Kabuuang Produkto",
        CS: "Kasalukuyang Stock",
        IV: "Halaga ng Imbentaryo",
        DA: "Araw-araw na Average",
        TSI: "Kabuuang Stock In",
        TSO: "Kabuuang Stock Out",
        TOR: "Rate ng Turnover",
        Tv: "Kabuuang Halaga",
        AST: "Aktibong Pagsubaybay ng SKU",
        UT: "Nasubaybayan na Units",
        SL: "Antas ng Stock",
        Value: "Halaga",
        IO: "PASOK/LABAS",
        T: "Turnover",
        unitsD: "Units/Araw",
        Sort: "Pag-uri-uriin",
        Sort_by: "Pag-uri-uriin ayon sa",
        Units_available: "Mga Unit na Magagamit",
        Units_unavailable: "Mga Unit na Hindi Magagamit",
        Current_assets: "Mga Kasalukuyang Asset",
        Search: "Maghanap",
        available: "Magagamit",
        assigned: "Itinalaga",
        AYSWD: "Sigurado ka bang gusto mong burahin?",
        PTS: "Matagumpay na nailipat ang bodega",
        AUS: "Matagumpay na na-update ang mga asset",
        ACS: "Matagumpay na nilikha ang mga asset",
        VSP: "Tingnan ang presyo ng pagbebenta",
        HUS: "Matagumpay na na-update ang kasaysayan",
    },
    ReplacementReturn: {
        selectProduct: "Mangyaring pumili ng produkto",
        selectReplacementProduct: "Pumili ng hindi bababa sa isang replacement product",
        validQuantity: "Maglagay ng valid na dami ng return",
        replacedSuccessfully: "Matagumpay na napalitan ang produkto",
        returnSuccessfully: "Matagumpay na naibalik ang produkto",
        failedProcess: "Nabigo ang pagproseso. Subukang muli.",
        return: "Ibalik",
        replace: "Palitan",
        typeSelectProduct: "Mag-type o pumili ng produkto...",
        returnQuantity: "Dami ng Ibabagsak",
        enterQuantity: "Ilagay ang Dami",
        replacementDate: "Petsa ng Pagpapalit",
        returnDate: "Petsa ng Pagbabalik",
        chooseCustomer: "Pumili ng Customer",
        additionalNotes: "Magdagdag ng karagdagang notes...",
        replacementProducts: "Mga Produkto ng Pagpapalit",
        addProducts: "Magdagdag ng Higit pang Produkto",
        tapSelect: "I-tap para pumili mula sa available na produkto",
        currently: "Kasalukuyan",
        item: "item",
        items: "mga item",
        selected: "napili",
        selectedItems: "Mga napiling item",
        hideDetails: "Itago ang higit pang detalye",
        showDetails: "Ipakita ang higit pang detalye",
        product: "produkto",
        priceLevel: "Piliin ang antas ng presyo",
        customPrice: "Maglagay ng custom na presyo",
        noReplaceHistory: "Walang nakitang history ng pagpapalit",
        replaceReturn: "Palitan at Ibalik",
        replaceReturnHistory: "Kasaysayan ng Pagpapalit at Pagbabalik"
    },
    OtherComponent: {
        mfgHistoryTitle: "Kasaysayan ng Paggawa",
        mfgHistoryDesc: "Subaybayan ang mga gawaing produkto ng stock",
        dailyOperation: "Mga Operasyon Araw-araw",
        freqUsed: "Mga aksyon na madalas gamitin upang mabilis na i-update ang mga rekord",
        manageCategory: "Pamahalaan ang Mga Kategorya",
        organizeCaterory: "Ayusin at pamahalaan ang mga kategorya ng produkto, gastos at asset",
        businessRecord: "Mga Rekord ng Negosyo",
        organizeRecord: "Ayusin at pamahalaan ang inyong mga rekord ng negosyo",
        trackHistory: "Subaybayan ang Kasaysayan",
        completeTracking: "Kumpletong kasaysayan para sa pag-audit at pagsubaybay",
        Verifyinventorycount: "Beripikahin ang bilang ng imbentaryo",
        Exchangerates: "Mga rate ng palitan",
        Productiontracking: "Pagsubaybay sa produksyon",
        Fixedassetregister: "Rehistro ng mga fixed asset",
        Storagelocations: "Mga lokasyon ng storage",
        warehouseAvailability: 'Availability ng produkto sa antas ng bodega',
        Logreviewspend: "I-log at suriin ang paggastos",
        Productgroupings: "Mga pangkat ng produkto",
        Classifyexpenditures: "I-klasipika ang mga gastos",
        Assetclassification: "Klasipikasyon ng asset",
        Manageexchanges: "Pamahalaan ang mga palitan",
        Returnauditlog: "Audit log ng pagbabalik",
        Interlocationmoves: "Paglipat sa pagitan ng mga lokasyon",
        Manageoperationscategoriesrecordsandhistory: "Pamahalaan ang mga operasyon, kategorya, rekord at kasaysayan"
    },
    no_permission_dialog: {
        title: 'Walang Pahintulot',
        historyDescription: "Wala kang pahintulot na tingnan ang Kasaysayan ng Transaksyon. Mangyaring makipag-ugnayan sa iyong administrator.",
        replacementHistoryDescription: "Wala kang pahintulot na tingnan ang Kasaysayan ng Pagpapalit at Pagbabalik. Mangyaring makipag-ugnayan sa iyong administrator.",
        transferHistoryDescription: "Wala kang pahintulot na tingnan ang Kasaysayan ng Paglilipat ng Warehouse. Mangyaring makipag-ugnayan sa iyong administrator."
    },
    OthersHistory: {
        title: "Pamahalaan ang Kasaysayan",
        transferHistory: "Pamahalaan ang Kasaysayan ng Paglilipat",
        transactionHistory: "Pamahalaan ang Kasaysayan ng Transaksyon",
        replacementHistory: "Pamahalaan ang Kasaysayan ng Pagpapalit at Pagbabalik"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "I-browse at bilhin ang mga produktong ibinahagi ng negosyo.",
        description: "I-browse ang mga produktong ibinahagi ng negosyo.",
        productsAvailable: "Mga produktong available",
        noImageAvailable: "Walang available na larawan",
        productDetails: "Detalye ng produkto",
        inStock: "may stock",
        availableVariants: "Mga available na opsyon",
        options: "mga opsyon",
        orders: "Mga order"
        ,
        searchProducts: "Maghanap ng mga produkto...",
        noProductsFound: "Walang produkto na natagpuan",
        tryDifferentKeyword: "Subukang maghanap gamit ang ibang keyword",
        variants: "Mga Variant",
        stock: "Stock",
        cart: "Cart",
        products: "Mga Produkto",
        viewCart: "Tingnan ang Cart",
        backToProducts: "Bumalik sa Mga Produkto",
        yourCart: "Ang Iyong Cart",
        clear: "I-clear",
        cartEmpty: "Walang laman ang iyong cart",
        cartEmptyDesc: "I-browse ang catalog at magdagdag ng mga produkto.",
        browseProducts: "I-browse ang Mga Produkto",
        selectedItems: "Mga Napiling Item",
        itemInCart: "item sa cart",
        itemsInCart: "mga item sa cart",
        customerDeliveryDetails: "Detalye ng Customer at Delivery",
        fullName: "Buong Pangalan",
        enterFullName: "Ilagay ang iyong buong pangalan",
        deliveryAddress: "Address ng Delivery",
        addressPlaceholder: "Kalye, gusali, lungsod, zip code...",
        orderNote: "Note sa Order (Opsyonal)",
        orderNotePlaceholder: "Espesyal na tagubilin o delivery notes...",
        paymentMode: "Paraan ng Bayad",
        subtotal: "Subtotal",
        items: "mga item",
        totalAmount: "Kabuuang Halaga",
        orderOnWhatsApp: "Mag-order sa WhatsApp 📲",
        orderPlaced: "Matagumpay na Nailagay ang Order! 🎉",
        orderPlacedDesc: "Naitala na ang iyong order at nabuksan ang WhatsApp.",
        continueShopping: "Magpatuloy sa Pamimili 🛍️",
        cartEmptyTitle: "Walang Laman ang Cart",
        cartEmptyToast: "Mangyaring magdagdag ng mga produkto bago mag-checkout.",
        incompleteTitle: "Hindi Kumpleto ang Detalye",
        incompleteToast: "Mangyaring punan ang lahat ng kinakailangang field.",
        nameRequired: "Kinakailangan ang buong pangalan",
        addressRequired: "Kinakailangan ang address ng delivery",
        catalogUnavailable: "Hindi Available ang Catalog",
        catalogUnavailableDesc: "Hindi aktibo ang catalog na ito. Makipag-ugnayan sa negosyo.",
        invalidCatalogLink: "Hindi Valid na Catalog Link 🚫",
        invalidCatalogDesc: "Kulang sa kinakailangang impormasyon ang page na ito.",
        missing: "Nawawala",
        catalogSlug: "Catalog Slug",
        goBackHome: "Bumalik sa Home",
        inventoryManagement: "Pamamahala ng Imbentaryo at Invoicing 🚀 Simply",
        enter: "Ilagay",
        select: "Pumili",
        // Catalog Order translations
        catalogOrders: 'Mga Order sa Katalogo',
        pending: 'Nakabinbin',
        converted: 'Na-convert',
        cancelled: 'Kanselado',
        totalRevenue: 'Kabuuang Halaga',
        totalCatalogOrders: 'Kabuuang Online Order',
        convertToSalesOrder: 'I-convert sa Sales Order',
        date: 'Petsa',
        status: 'Katayuan',
        action: 'Aksyon',
        searchOrders: 'Maghanap ng customer o telepono...',
        noMatchingOrders: 'Walang tumutugmang order',
        noStatusOrders: 'Walang {status} order na natagpuan',
        tryDifferentSearch: 'Subukang maghanap gamit ang ibang pangalan ng customer o numero ng telepono.',
        noOrdersWithStatus: 'Kasalukuyang walang order na may {status} status.',
        noOrdersYet: 'Wala Pang Order sa Katalogo',
        noOrdersDescription: 'Ang mga order mula sa iyong online na katalogo ay lalabas dito.',
        guestCustomer: 'Bisita',
        item: 'Item',
        moreItems: '+{count} pa',
        viewDetails: 'Tingnan ang Detalye',
        viewSalesOrder: 'Tingnan ang Sales Order',
        cancelOrder: 'Kanselahin ang Order',
        confirmCancelTitle: 'Kanselahin ang Order sa Katalogo?',
        confirmCancelOrder: 'Sigurado ka bang gusto mong kanselahin ang order na ito? Hindi na ito maibabalik.',
        keepOrder: 'Hindi, Panatilihin ang Order',
        confirmCancelAction: 'Oo, Kanselahin ang Order',
        orderNotFound: 'Hindi Natagpuan ang Order',
        orderNotFoundDescription: 'Hindi mahanap ang order na ito o maaaring wala kang pahintulot na tingnan ito.',
        backToCatalogOrders: 'Bumalik sa Mga Order sa Katalogo',
        placedOn: 'Inorder noong',
        totalItems: 'Kabuuang Item',
        orderedProducts: 'Mga Inorder na Produkto',
        itemDetails: 'Detalye ng Item',
        quantity: 'Dami',
        unitPrice: 'Presyo bawat Yunit',
        total: 'Kabuuan',
        variant: 'Baryante',
        customerInformation: 'Impormasyon ng Customer',
        additionalFields: 'Karagdagang Field',
        fields: 'field',
    },
    stockNew: {
        Npay: "Wala pang naidagdag na produkto",
        emptydesc: "Pumili ng produkto mula sa iyong catalog at ilagay ang incoming quantity para i-record ang stock.",
        tipText: "Tip: Maaari ka ring mag-upload ng excel file",
        OT: "Kabuuang Order",
        Collapse: "I-collapse"
    },
    deleteBulk: {
        Bulkoperation: "Bulk Operation",
        Applyproducts: "Ilapat ang mga aksyon sa maraming produkto",
        Bulkupload: "Bulk Upload",
        ImportCSVfile: "Mag-import ng mga produkto gamit ang Excel o CSV file",
        or: "o",
        Bulkdelete: "Bulk Delete",
        Permanentlyallproducts: "Permanenteng tanggalin ang lahat ng produkto",
        IrrText: "Ang bulk delete ay hindi na mababawi. Mag-export muna ng backup kung kinakailangan.",
        SeP: "Mga Napiling Produkto",
        sP: "Piliin ang Produkto",
        DA: "Tanggalin Lahat",
        DP: "Tanggalin ang mga Produkto",
        sL: "Piliin Lahat",
        ASDE: "Sigurado ka bang gusto mong tanggalin ang lahat ng produkto maliban sa",
        ASDAllP: "Sigurado ka bang gusto mong tanggalin ang lahat ng produkto?",
        ASD: "Sigurado ka bang gusto mong tanggalin",
        products: "mga produkto",
        TACBU: "Hindi na mababawi ang aksyong ito.",
        LP: "Naglo-load ng mga produkto...",
        FM: "Kinukuha pa...",
        NPF: "Walang nakitang produkto.",
        LMP: "Naglo-load pa ng mga produkto..."
    },
    NewVariantModal: {
        Definevariantsassign: "I-define ang mga variant at magtalaga ng quantities",
        Nothingallocated: "Walang na-assign",
        Overallocated: "Over-allocated",
        Fullyallocated: "Fully allocated",
        Overby: "Over by",
        Allvariantsneedaname: "Lahat ng variant kailangan ng pangalan.",
        Reducequantities: "Bawasan ang quantities.",
        Overallocatedby: "Over-allocated by",
        Quantitiesmustmatchthetotalavailability: "Dapat tumugma ang quantities sa total availability.",
        Allocatequantitiesacrosswarehouses: "I-allocate ang quantities sa mga warehouse",
        Notfullydistributed: "Hindi pa fully distributed:",
        remaining: "natira",
        Qty: "Qty",
        Inactive: "Inactive",
        left: "natira"
    },
    ProductFormNew: {
        BasicInfo: "Impormasyong Pangunahin",
        ProductImage: "Larawan ng Produkto",
        Images: "Mga Larawan",
        Pricing: "Presyo",
        Everypriceneedsbothalabelandanamount: "Bawat presyo ay kailangan ng label at halaga",
        AddalabellikeWholesaleorRetailtoidentifythisprice: 'Magdagdag ng label tulad ng "Wholesale" o "Retail" para matukoy ang presyong ito',
        AddMultiplePrice: "Magdagdag ng Maramihang Presyo",
        NoPhotosLetAiFind: "Walang mga larawan? Hayaan ang AI na maghanap ng larawan ng produkto",
        AddProductImagesTitle: "Magdagdag ng Larawan ng Produkto",
        ChooseHowToAddPhotos: "Pumili kung paano mo gustong magdagdag ng larawan para sa produktong ito:",
        SearchWithAi: "Maghanap gamit ang AI",
        SearchWithAiDesc: "Awtomatikong maghanap at pumili ng larawan ng produkto gamit ang AI",
        FilesFileExplorer: "Mga File (File Explorer)",
        FilesFileExplorerDesc: "Pumili ng mga larawan mula sa iyong computer",
        AiProductImageFinder: "Tagahanap ng Larawan ng Produkto gamit ang AI",
        AiProductImageFinderDesc: "Maghanap at pumili ng mga larawan para sa iyong produkto",
        TypeProductNamePlaceholder: "I-type ang pangalan ng produkto...",
        SearchForYourProduct: "Maghanap para sa iyong produkto",
        SearchForYourProductHint: `Subukan ang pangalan ng brand o produkto`,
        ImagesSelected: "mga larawang napili",
        AddSelected: "Idagdag ang Napili"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "Mag-define ng bagong custom field",
        AttributeName: "Pangalan ng Attribute",
        DataType: "Uri ng Data",
        Noattributesfound: "Walang attribute na natagpuan",
        ManageAttributes: "Pamahalaan ang Attributes",
        Editordeleteexistingattributes: "I-edit o tanggalin ang mga umiiral na attribute",
        UpdateAttribute: "I-update ang Attribute",
        Saving: "Ini-save..."
    },
    NewExpenses: {
        Noexpensesyet: "Wala pang gastos",
        Addyourfirstexpensetostarttrackingyourspending: "Magdagdag ng iyong unang gastos upang simulan ang pag-track ng iyong paggastos.",
        TOTALEXPENSES: "KABUUANG GASTOS",
        ENTRIES: "ENTRI",
        BYCATEGORY: "AYON SA KATEGORYA",
        Nocategoriestodisplay: "Walang kategorya na ipapakita",
        DateanfTime: "Petsa at Oras"
    },
    PurchaseSales: {
        CancelOrder: "Kanselahin ang order",
        ReopenOrder: "Buksan muli ang order",
        Reopen: "Buksan muli",
        ConfirmCancelOrder: "Sigurado ka bang gusto mong kanselahin ang order na ito?",
        ConfirmReopenOrder: "Sigurado ka bang gusto mong buksan muli ang order na ito?",
        OrderCancelledSuccessfully: "Matagumpay na nakansela ang order.",
        OrderReopenedSuccessfully: "Matagumpay na nabuksan muli ang order.",
        CancelledBy: "Kinansela ni",
        Cancelled: "Nakansela",
        ConvertPriceBasedOnUnitConversion: "I-convert ang Presyo Batay sa Conversion ng Unit",
        MarkPaymentAsPending: "Markahan ang Bayad bilang Nakabinbin",
        PendingReceivableDesc: "Halaga na naitala bilang matatanggap. Itala ang bayad kapag natanggap.",
        PendingPayableDesc: "Halaga na naitala bilang babayaran. Itala ang bayad kapag nabayaran.",
        SelectCustomerFirst: "Pumili muna ng customer",
        SelectSupplierFirst: "Pumili muna ng supplier",
        SelectItemsFirst: "Pumili muna ng kahit isang item",
        PaymentMarkedPendingDesc: "Nakatakda ang bayad bilang nakabinbin. I-uncheck ang 'Markahan ang Bayad bilang Nakabinbin' para maitala ang bayad ngayon.",
        SelectCustomerAndItemFirst: "Mangyaring pumili ng customer at kahit isang item muna",
        SelectSupplierAndItemFirst: "Mangyaring pumili ng supplier at kahit isang item muna",
        SelectCustomerProductFirst: "Pumili muna ng customer at produkto",
        SelectSupplierProductFirst: "Pumili muna ng supplier at produkto",
        Receivables: "Mga Natatanggap",
        Payables: "Mga Babayaran",
        AccessDenied: "Access Denied",
        YouDonthaeP: "Wala kang pahintulot na tingnan ang pahinang ito. Kung sa tingin mo ay pagkakamali ito, mangyaring makipag-ugnayan sa iyong administrator.",
        purchase: "Bili",
        sales: "Benta",
        Areyousureyouwantto: "Sigurado ka bang gusto mong",
        Thisactionwillupdateitsstatus: "Ia-update ng aksyong ito ang status nito.",
        ReasonOPtional: "Dahilan (Opsyonal)",
        Enterareasonfor: "Ilagay ang dahilan para sa",
        optionalDot: "(opsyonal)...",
        Reject: "Tanggihan",
        ConfirmOrder: "Kumpirmahin ang Order",
        RejectOrder: "Tanggihan ang Order",
        Previous: "Nakaraan",
        First: "Una",
        Order: "Order",
        Items: "Mga Item",
        Memo: "Memo",
        SelectDateRange: "Piliin ang Saklaw ng Petsa",
        List: "Listahan",
        Board: "Board",
        View: "Tingnan",
        CreateSalesOrder: "Gumawa ng Sales Order",
        CreatePurchaseOrder: "Gumawa ng Purchase Order",
        successfully: "matagumpay",
        ManageAttachments: "Pamahalaan ang Mga Attachment",
        Stockoutitemsimmediatelyaftersaving: "I-stock out agad ang mga item pagkatapos mag-save.",
        Stockinitemsimmediatelyaftersavingthisorder: "I-stock in agad ang mga item pagkatapos mag-save ng order na ito.",
        ViewAttachments: "Tingnan ang Mga Attachment",
        MemoAttachments: "Memo at Attachments",
        ReceivedDate: "Petsa ng Natanggap",
        ShippedDate: "Petsa ng Naipadala",
        OrderDate: "Petsa ng Order",
        OrderDetails: "Detalye ng Order",
        Subtotal: "Subtotal",
        OrderSummary: "Buod ng Order",
        AddItem: "Magdagdag ng Item",
        NewSalesOrder: "Bagong Sales Order",
        NewPurchaseOrder: "Bagong Purchase Order",
        Createandmanageyour: "Gumawa at pamahalaan ang iyong",
        orders: "mga order",
        Removeitem: "Alisin ang item",
        UnitPrice: "Presyo ng Unit",
        PurchaseOrder: "Purchase Order",
        SalesOrder: "Sales Order",
        PurchaseInvoice: "Purchase Invoice",
        SalesInvoice: "Sales Invoice",
        PurchaseOrdernotfound: "Hindi natagpuan ang Purchase Order",
        Approve: "Aprubahan",
        MarkasShipped: "Markahan bilang Naipadala",
        MarkasReceived: "Markahan bilang Natanggap",
        Marking: "Minamarkahan...",
        PartiallyShip: "Bahagyang Naipadala",
        PartiallyReceive: "Bahagyang Natanggap",
        Deleting: "Tinatanggal...",
        Transaction: "Transaksyon",
        Details: "Detalye",
        Item: "Item",
        Received: "Natanggap",
        Shipped: "Naipadala",
        Ordered: "Inorder",
        units: "unit",
        Overalldiscount: "Kabuuang Diskwento",
        Transactions: "Mga Transaksyon",
        Notransactionsfound: "Walang transaksyon na natagpuan",
        OrderedQty: "Inorder na Qty",
        Totalqty: "Kabuuang Qty",
        StockingOut: "Nagpapalabas ng stock...",
        StockingIn: "Nagpapapasok ng stock...",
        thiorderUpdateStuau: "na order na ito? Ia-update ng aksyong ito ang status nito.",
        TransactionDetails: "Detalye ng Transaksyon",
        Fetchingtransactiondetails: "Kinukuha ang detalye ng transaksyon...",
        Nodetailsfoundforthistransaction: "Walang detalye para sa transaksyong ito.",
        TotalBreakDown: "Kabuuang Breakdown",
        ChangeAmount: "Halaga ng Sukli",
        Attachments: "Mga Attachment",
        PoNumber: "PO Number",
        SoNumber: "SO Number",
        partner: "Partner",
        EditPurchase: "I-edit ang Pagbili",
        EditSales: "I-edit ang Pagbebenta",
        PurchaseOrderDetails: "Detalye ng Purchase Order",
        SalesOrderDetails: "Detalye ng Sales Order",
        purchase_order: "Order ng pagbili",
        purchase_order_creation: "Paglikha ng order ng pagbili",
        purchase_order_edit: "I-edit ang order ng pagbili",
        purchase_order_cancel: "Kanselahin ang order ng pagbili",
        purchase_order_reopen: "Buksan muli ang order ng pagbili",
        purchase_order_receive: "Pagtanggap ng order ng pagbili",
        sales_order: "Order ng benta",
        sales_order_creation: "Paglikha ng order ng benta",
        sales_order_edit: "I-edit ang order ng pagbebenta",
        sales_order_cancel: "Kanselahin ang order ng pagbebenta",
        sales_order_reopen: "Buksan muli ang order ng pagbebenta",
        sales_order_receive: "Naipadala ang order ng benta",
        purchase_order_approval: "Pag-apruba ng order ng pagbili",
        sales_order_approval: "Pag-apruba ng order ng benta",
        can_do_available_warehouse: "Magagamit na bodega",
        add_batch: "Pag-apruba ng paggawa ng batch",
        OrderType: "Uri ng Order",
        SelectOrderType: "Pumili ng Uri ng Order",
        OrderTypePrepaid: "Prepaid",
        OrderTypeCOD: "Cash on Delivery",
        OrderTypePayLater: "Magbayad Mamaya",
        OrderTypePartialPayment: "Bahagyang Pagbabayad",
        OrderTypeSubscription: "Subskripsyon",
        viewAvailabilty: 'Tingnan ang Availability',
        NotReceived: "Hindi Natanggap",
        NotShipped: "Hindi Na-ship",
        PartiallyReceived: "Bahagyang Natanggap",
        PartiallyShipped: "Bahagyang Na-ship",
    },
    PriceReference: {
        HighPrice: "Mataas na Presyo",
        LowPrice: "Mababang Presyo",
        LastPrice: "Huling Presyo",
        LastPurchasePrice: "Huling Presyo ng Pagbili",
        Nopricerecordsfound: "Walang nahanap na tala ng presyo",
        BuyingPriceReference: "Sanggunian ng Presyo sa Pagbili",
        SellingPriceReference: "Sanggunian ng Presyo sa Pagbebenta",
        Viewstockinpricesfortheselectedvendorandproduct: "Tingnan ang stock-in prices para sa napiling vendor at produkto",
        Viewstockoutpricesfortheselectedcustomerandproduct: "Tingnan ang stock-out prices para sa napiling customer at produkto"
    },
    SubscriptionLocale: {
        premiumPlan: "Premium Plan",
        heading: "Gumawa ng mga Desisyon sa Negosyo",
        headingHighlight: "Batay sa Data",
        subtitle: "I-unlock ang buong kapangyarihan ng iyong business analytics — walang limitasyon, walang kompromiso.",
        choosePlan: "Piliin ang iyong plano",
        monthly: "Buwan-buwan",
        annual: "Taun-taon",
        oneTime: "Isang Pagkakataon (Buwanang)",
        perMonth: "bawat buwan",
        perYear: "bawat taon",
        bestValue: "Pinakamagandang Halaga",
        continueWith: "Magpatuloy sa",
        perMonthShort: "buwan",
        perYearShort: "taon",
        troubleWithSubscription: "Problema sa subscription?",
        contactUs: "Makipag-ugnayan sa Amin",
        paymentNotReady: "Hindi handa ang pagbabayad",
        checkoutError: "ERROR SA CHECKOUT",
        pricePreviewError: "ERROR SA PREVIEW NG PRESYO",
        subNotAvailable: "Hindi available ang subscription",
        subNotAvailableDesc: "Ang web subscriptions ay kasalukuyang hindi available sa iyong bansa. Mangyaring mag-subscribe sa pamamagitan ng aming mobile app o makipag-ugnayan sa amin para sa tulong."
    },
    SubscriptionLocale2: {
        GoPro: "Pumunta sa Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "Gumawa ng mas matalinong desisyon na sinusuportahan ng totoong data ng negosyo",
        ExploreProPlans: "Tuklasin ang mga Pro Plan"
    },
    emptyWarehouseState: {
        tips: [
            "Maaari kang magkaroon ng maraming warehouse para sa iba't ibang pisikal na lokasyon",
            "Bawat produkto ay nagtetrack ng stock sa bawat warehouse nang hiwalay",
            'Gamitin ang "Transfer Warehouse" upang ilipat ang stock sa pagitan ng mga lokasyon'
        ],
        NoWarehousesConfigured: "Walang Warehouse na Na-configure",
        desc: "Magsimula sa pagdaragdag ng iyong mga warehouse (kung may higit sa isa), pagkatapos ay magdagdag ng mga produkto at i-record ang stock movements.",
        WarehouseSetupTips: "Mga Tip sa Pag-setup ng Warehouse",
        Noproductselected: "Walang produktong napili",
        Selectaproductfromthelefttoviewlowstockdetails: "Pumili ng produkto sa kaliwa upang makita ang mga detalye ng mababang stock.",
        Chooseaproductfromthelist: "Pumili ng produkto mula sa listahan",
        SelectProduct: "Piliin ang Produkto",
        SetQuantity: "Itakda ang Dami",
        Showing: "Nagpapakita",
        products: "mga produkto",
        Continue: "Magpatuloy",
        SaveSafetyStock: "I-save ang Safety Stock",
        SafetyStockSaved: "Na-save na ang Safety Stock!",
        hasbeensetto: "ay naitakda sa",
        AddAnother: "Magdagdag pa",
        Chooseaproduct: "Pumili ng produkto",
        Step: "Hakbang",
        of: "ng",
        Setsafetyquantity: "Itakda ang safety quantity",
        Complete: "Tapos na",
        SafetyStockQuantity: "Safety Stock Quantity",
        Minimumunitsdropsbelowthisnumber: "Pinakamababang unit na dapat laging itago sa stock. May alert kapag bumaba ang stock sa ilalim ng numerong ito.",
        NewSafetyStock: "Bagong Safety Stock",
        SafetyNow: "Safety Ngayon",
        SettingTo: "Itinatakda sa",
        Change: "Baguhin",
        sell: "ibenta",
        cost: "halaga",
        BulUD: "Bulk Upload/Delete"
    },
    SimplyLoginUI: {
        sslEncryption: "256-bit SSL Encryption",
        dataPrivate: "100% private ang iyong data",
        worksOnDevices: "Gumagana sa Android at iPhone",
        realTimeSync: "Real-time sync sa lahat ng device",
        cloudBackup: "Automatic cloud backup",
        availableOn: "Available sa Web, Android at iOS",
        tagline: "Ang iyong inventory,",
        taglineEm: "maganda at simple.",
        subtitle: "Mag-sign in upang pamahalaan ang stock, subaybayan ang benta, at panatilihing gumagalaw ang iyong negosyo — lahat sa isang lugar.",
        feature1Title: "Real-time stock tracking",
        feature1Desc: "Alam mo nang eksakto kung ano ang nasa bawat warehouse, laging updated.",
        feature2Title: "Sales at purchase orders",
        feature2Desc: "Gumawa ng invoice, pamahalaan ang mga vendor, at subaybayan ang bawat transaksyon.",
        feature3Title: "Mga smart report",
        feature3Desc: "Mga ulat sa pananalapi, stock, at araw-araw na galaw sa isang tingin.",
        feature4Title: "Real-time sync sa lahat ng device",
        feature4Desc: "Ang mga pagbabago sa telepono ay agad na lumalabas sa web — at vice versa.",
        rating1: "Na-rate",
        rating2: "4.9/5",
        rating3: "ng 10,000 wholesale businesses",
        brandName: "Simply",
        greeting: "Hello ulit! 👋",
        noPasswordNeeded: "Mag-sign in para ma-access ang iyong inventory — Android, iPhone at web, lahat naka-sync.",
        badge1: "Stock Management",
        badge2: "Sales Tracking",
        badge3: "Reports",
        trustEncryptedTitle: "Encrypted",
        trustEncryptedSub: "256-bit SSL",
        trustPrivateTitle: "Private",
        trustPrivateSub: "Iyong data lamang",
        trustBackedTitle: "Naka-backup",
        trustBackedSub: "Araw-araw na auto",
        availableOnLabel: "AVAILABLE ON",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "Web",
        syncBadge: "Lahat ng device ay agad na nag-syync sa real-time",
        securityNote: "100% secure.",
        securityDesc: "Bank-grade encryption ang nagpoprotekta sa lahat ng data mo. Binabasa lang namin ang iyong pangalan at email — wala nang iba pa, kailanman.",
        signingIn: "Nagsa-sign in ka…",
        termsPrefix: "Sa pag-sign in, sumasang-ayon ka sa",
        privacyPolicy: "Patakaran sa Privacy",
        and: "at",
        termsOfService: "Mga Tuntunin ng Serbisyo",
        google: "Mag-login gamit ang Google"
    },
    BatchLocal: {
        BatchName: "Pangalan ng Batch",
        EnterBatchName: "Ilagay ang pangalan ng batch",
        EnterNotes: "Ilagay ang mga tala",
        ExpiredDate: "Petsa ng Pag-expire",
        Selectexpireddate: "Piliin ang petsa ng pag-expire",
        BatchStatus: "Status ng Batch",
        CreatedDate: "Petsa ng Paglikha",
        Areyousureyouwanttodeletethisbatch: "Sigurado ka bang gusto mong tanggalin ang batch na ito?",
        Youhavencreatedanybatchforthisproduct: "Hindi ka pa lumikha ng anumang batch para sa produktong ito.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "Lumikha ng iyong unang batch upang simulan ang pagsubaybay sa stock ayon sa lot at expiry.",
        Nobatchesyet: "Wala pang batch",
        Whatisbatchmanagement: "Ano ang batch management?",
        Howithelpsyourbusiness: "Paano ito nakakatulong sa iyong negosyo",
        Trackbylotnumber: "Subaybayan ayon sa lot number",
        Trackbylotnumberdesc: "I-group ang stock ayon sa manufacturer batch para malaman mo palagi kung aling lot galing ang isang unit.",
        Expirydatecontrol: "Kontrol sa petsa ng expiry",
        Expirydatecontroldesc: "Makakuha ng alert bago mag-expire ang stock. Ibenta muna ang mga lumang batch at bawasan ang basura nang awtomatiko.",
        Fulltraceability: "Buong traceability",
        Fulltraceabilitydesc: "Tingnan nang eksakto kung aling batch ang ginamit sa bawat transaksyon — mahusay para sa audit at recall.",
        Supplierwisestock: "Stock ayon sa supplier",
        Supplierwisestockdesc: "Paghiwalayin ang stock mula sa iba't ibang supplier kahit pareho ang produkto. Ihambing ang kalidad batch by batch.",
        Createyourfirstbatchbutton: "Lumikha ng iyong unang batch",
        Nomatchesfound: "Walang nahanap na tugma",
        NomatchesfounddescBefore: "Hindi namin mahanap ang anumang batch na tumutugma sa ",
        NomatchesfounddescAfter: "",
        Clearsearch: "I-clear ang paghahanap",
        Nohistoryfoundthisbatch: "Walang nahanap na history para sa batch na ito",
        ComprehensiveDetails: "Mga detalyadong impormasyon",
        History: "Kasaysayan",
        InBatch: "Sa Batch",
        Noproductfoundinthisbatch: "Walang produktong nahanap sa batch na ito",
        SelectBatch: "Piliin ang Batch",
        available: "available",
        Searchbatches: "Maghanap ng mga batch...",
        Expires: "Mag-e-expire",
        Nobatchesfound: "Walang nahanap na batch",
        ManageBatches: "Pamahalaan ang mga Batch",
        Batchmanagement: "Batch Management",
        Trackstockexpiry: "Subaybayan ang stock ayon sa batch at expiry",
        Turnoffbatchmanagement: "I-off ang batch management?",
        Yourgsafe: "Ang iyong kasalukuyang batch data ay nananatiling ligtas.",
        Reenableanytimefrom: "Maaari mong i-enable ulit anumang oras mula sa",
        Otherstab: "Others tab",
        AddBatch: "Magdagdag ng Batch",
        Total: "Kabuuan",
        AssignProduct: "Italaga ang Produkto",
        EditProductAssignment: "I-edit ang Product Assignment",
        AssignProducttoBatch: "Italaga ang Produkto sa Batch",
        Updateproductconfiguration: "I-update ang configuration ng produkto",
        Step1of2: "Hakbang 1 ng 2",
        Step2of2: "Hakbang 2 ng 2",
        Selectvariantwarehouse: "Piliin ang variant at warehouse",
        SelectedProduct: "Napiling Produkto",
        AssignQuantity: "Itakda ang Dami",
        BatchInfo: "Impormasyon ng Batch",
        Wecouldnthisproductidentifier: "Hindi namin mahanap ang anumang batch na nauugnay sa produktong identifier na ito.",
        NoActiveBatches: "Walang Active Batches",
        Endofresults: "Katapusan ng mga resulta",
        Expiry: "Pag-expire",
        NeedsReview: "Kailangan ng pagsusuri",
        Pending: "Nakabinbin",
        Rejected: "Tinanggihan",
        Approved: "Naaprubahan",
        WaitingForApproval: "Naghihintay ng pag-apruba",
        WaitingForApprovalDesc: "Susuriin at aaprubahan ng iyong may-ari ang batch na ito sa lalong madaling panahon.",
        BatchRejected: "Tinanggihan ang batch",
        BatchRejectedDesc: "Tinanggihan ng iyong may-ari ang batch na ito.",
        Reason: "Dahilan",
        Approve: "Aprubahan",
        Reject: "Tanggihan",
        ConfirmApproveTitle: "Aprubahan ang batch",
        ConfirmRejectTitle: "Tanggihan ang batch",
        ConfirmApprovalAction: "Sigurado ka bang gusto mong {action} ang batch na ito? Maa-update nito ang status nito.",
        ReasonOptional: "Dahilan (Opsyonal)",
        EnterReasonPlaceholder: "Maglagay ng dahilan para sa {action} (opsyonal)",
        Processing: "Pinoproseso...",
        BatchActivatedSuccess: "Matagumpay na na-activate ang batch",
        BatchDeactivatedSuccess: "Matagumpay na na-deactivate ang batch",
        BatchDeletedSuccess: "Matagumpay na nabura ang batch",
        BatchApprovedSuccess: "Matagumpay na naaprubahan ang batch",
        BatchRejectedSuccess: "Matagumpay na tinanggihan ang batch",
        SearchByBatchName: "Maghanap ayon sa pangalan ng batch...",
        YesTurnOff: "Oo, patayin",
        KeepItOn: "Panatilihing naka-on"
    },
    CategoryNewL: {
        TotalCategories: "Kabuuan ng mga Kategorya",
        lastaddedcategory: "huling idinagdag na kategorya",
        acrossalltypes: "sa lahat de mga uri",
        MostRecent: "Pinakabago",
        YesD: "Oo, burahin",
        AllAssociated: "Maaaring maapektuhan ang lahat de kaugnay na produkto"
    },
    OverDas: {
        movestockbetweenlocations: "Ilipat ang stock",
        no_activity_yet: "Wala pang aktibidad",
        no_activity_sub: "Mga benta, pagbili, paggalaw ng stock at pagbabalik ay lilitaw dito sa real time.",
        make_first_sale: "Gumawa ng Unang Benta",
        add_stock: "Magdagdag ng Stock",
        all_stock_healthy: "Lahat ng antas ng stock ay malusog",
        all_stock_healthy_sub: "Walang item na nauubos. Itakda ang minimum threshold sa mga produkto upang makatanggap ng mga alert dito.",
        set_stock_thresholds: "Itakda ang Stock Thresholds",
        no_warehouses_setup: "Walang naka-set up na warehouse",
        no_warehouses_setup_sub: "Magdagdag ng warehouse upang simulan ang pagsubaybay kung saan nakaimbak ang iyong stock at pamahalaan ang mga lokasyon.",
        add_first_warehouse: "Magdagdag ng Unang Warehouse",
        Customer: "Mga Customer",
        PurchasevsSales: "Pagbili vs Benta",
        Financialperformancechart: "Tsart ng pinansyal na pagganap",
        QuickActions: "Mabilis na Aksyon",
        Frequentlyused: "Madalas gamitin",
        Addinventory: "Magdagdag ng imbentaryo",
        Dispatchitems: "I-dispatch ang mga item",
        Addorder: "Magdagdag ng order",
        Newitem: "Bagong item",
        Inventoryaccess: "Access sa imbentaryo",
        Itemsneedingreorder: "Mga item na kailangang i-reorder",
        Latesttransactions: "Pinakabagong transaksyon",
        Operationalsummary: "Buod ng operasyon",
        ViewAll: "Tingnan Lahat",
        Manage: "Pamahalaan",
        RecentActivity: "Kamakailang Aktibidad",
        LowStockAlerts: "Mga Alerto sa Mababang Stock",
        Primary: "Pangunahin",
        TotalWarehouses: "Kabuuang Warehouse"
    },
    SerialLocal: {
        ShowOrHideFields: "Ipakita o itago ang mga field",
        ShowOrHideFieldsDesc: "I-tap ang anumang item sa ibaba upang isama o alisin ito mula sa naka-print na invoice. Agad na ilalapat ang mga pagbabago.",
        Manufacturesettings: "Mga setting ng pagmamanupaktura",
        Showbuyingprice: "presyo ng pagbili / halaga ng produkto",
        Showadditionalcost: "karagdagang halaga",
        Costbreakdown: "Paghahati-hati ng gastos",
        Unitcost: "Halaga bawat yunit",
        Rawmaterialstotal: "Kabuuan ng hilaw na materyales",
        Confirmentry: "Kumpirmahin ang entry",
        SaveSerials: "I-save ang Serials",
        SerialNumber: "Serial Number",
        selected: "napili",
        added: "idinagdag",
        Serialnumbers: "Mga serial number",
        ResetAll: "I-reset lahat",
        Wecouldnfindthis: "Hindi kami makahanap ng available na serial numbers para sa produktong ito.",
        Nounitsfound: "Walang nahanap na unit",
        Searchingserialnumbers: "Naghahanap ng serial numbers...",
        Scanorenterstock: "I-scan o i-enter ang serials para sa bagong stock",
        Whataserialnumber: "Ano ang serial number?",
        Auniqueidentifieryourinventorylifecycle: "Isang unique identifier sa bawat unit — nagbibigay-daan sa iyo na i-track ang bawat indibidwal na item sa buong inventory lifecycle mo.",
        Trackedstockout: "Tracked stock out",
        Chooseexactlyselected: "Piliin nang eksakto kung aling mga serial numbers ang aalis. Tanging mga serial na naka-stock para sa produktong ito ang ipinapakita — ang quantity ay maglo-lock kapag nakapili ka na ",
        SelectSerialstoout: " - Pumili ng Serials na ilalabas",
        Thisinvoicegeneratedusingwwwsimplstockco: "Ang invoice na ito ay ginawa gamit ang www.simplstock.co",
        AuthorizedSignature: "Authorized Signature",
        Invoicesettings: "Mga setting ng invoice",
        Draw: "I-draw",
        Taptoselectordeselectitems: "I-tap para pumili o alisin ang pagpili sa mga item",
        Thissignaturewillbeadded: "Ang signature na ito ay idaragdag sa ibaba ng iyong naka-print na invoice.",
        SignatureOptions: "Mga Opsyon sa Signature",
        Upload: "I-upload",
        DrawSignature: "I-draw ang Signature",
        UploadSignature: "I-upload ang Signature",
        Clear: "I-clear",
        ShowStaffName: "Pangalan ng Staff",
        ShowSKU: "SKU",
        ShowBusinessName: "Pangalan ng Negosyo",
        ShowProductName: "Pangalan ng Produkto",
        ShowBusinessPhoneNumber: "Numero ng Telepono",
        ShowBusinessEmail: "Email",
        ShowBusinessAddress: "Address",
        ShowProductImage: "Larawan ng Produkto",
        ShowPaymentDetails: "Mga Detalye ng Pagbabayad",
        ShowCategory: "Kategorya",
        ShowVariant: "Variant",
        ShowWarehouse: "Warehouse",
        ShowAttributes: "Attributes",
        ShowQuantity: "Quantity",
        ShowDiscount: "Discount",
        ShowTax: "Tax",
        ShowPrice: "Presyo",
        ShowTotalPrice: "Kabuuang Presyo ng Produkto",
        ShowExpenses: "Gastos",
        ShowSignature: "Signature",
        ShowNote: "Note",
        ShowSerialNumber: "Serial Number",
        Invoicesettingsapplied: "Invoice settings applied. Tingnan ang invoice para sa mga pagbabago.",
        EnterSerialNumber: "Ilagay ang Serial Number",
        showAttachment: "Attachment"
    },
    FewLocal: {
        SelectBin: "Piliin ang Bin",
        Live: "Live",
        Monitorinventorystocklevels: "Subaybayan ang imbentaryo, paggalaw at antas ng stock",
        StockControlCentre: "Stock Control Centre",
        Nochartdataavailable: "Walang available na chart data",
        Disabled: "Hindi aktibo",
        Enabled: "Aktibo"
    },
    Bin: {
        Bin: "Bin",
        Add: "Magdagdag",
        NoBinsAddedYet: "Wala pang bin na idinagdag",
        BinLocationsHelp: "Tinutulungan ka ng bin locations na i-track ang stock sa eksaktong posisyon sa loob ng warehouse na ito — walang pangangailangan na maghanap pa.",
        NameThemByPosition: "Pangalanan ayon sa posisyon:",
        AddBinLocation: "Magdagdag ng Bin Location",
        BinLocations: "bin locations",
        BinNameRequired: "Kailangan ang pangalan ng bin",
        EditBin: "I-edit ang Bin",
        AddBin: "Magdagdag ng Bin",
        EnterBinName: "Pangalan ng Bin",
        EnterBinNamePlaceholder: "Ilagay ang pangalan ng bin",
        BinStatus: "Status ng Bin",
        BinNotes: "Mga Tala",
        EnterBinNotesPlaceholder: "Magdagdag ng mga tala...",
        ViewInventory: "Tingnan ang Inventory",
        Inventory: "Inventory",
        TrymatchingadifferentSKUname: "Subukan ang ibang SKU o pangalan.",
        Thisbinlocationcurrentlyempty: "Ang lokasyon ng bin na ito ay kasalukuyang walang laman.",
        Loadingbins: "Naglo-load ng mga bin...",
        bins: "bins",
        ManageBin: "Pamahalaan ang Bin",
        Print: "I-print",
        SBin: "Pinagmulang Bin",
        DBin: "Patutunguhang Bin"
    },
    WarehouseExcel: {
        title: "I-upload ang mga Warehouse & Bin Locations",
        description: "Sundin ang mga hakbang sa ibaba upang gumawa ng maraming warehouse kasama ang kanilang bin locations gamit ang Excel file.",
        bulkUploadGuide: "Gabay sa Bulk Upload",
        step1: "Hakbang 1",
        downloadTemplate: "I-download ang Excel template",
        downloadTemplateDesc: "Kunin ang opisyal na template na may lahat ng kinakailangang column headers. Huwag baguhin o tanggalin ang anumang column.",
        downloadTemplateBtn: "I-download ang Template",
        step2: "Hakbang 2",
        fillExcelFile: "Punan ang Excel file",
        fillExcelDesc: "Ang bawat row ay kumakatawan sa isang warehouse. Punan ang lahat ng column — para sa bin locations, ilagay ang lahat ng bin names na pinaghihiwalay ng comma sa <code>Bin Names</code> column.",
        step3: "Hakbang 3",
        thingsToKeepInMind: "Mga bagay na dapat tandaan",
        rulesDesc: "Bago i-upload, siguraduhing sumusunod ang iyong file sa mga patakarang ito.",
        step4: "Hakbang 4",
        uploadYourFile: "I-upload ang iyong file",
        uploadDesc: "Kapag napuno na, i-upload the file sa ibaba. Awtomatikong gagawa ang system ng lahat ng warehouse at bin locations.",
        rules: ["Isang row bawat warehouse", "Mga bin name na pinaghihiwalay ng comma sa isang cell", "Huwag baguhin ang column header names", "Ang duplicate na bin names sa isang warehouse ay lalaktawan", "Numero ng telepono na may country code", "Tanging .xlsx o .xls files ang tinatanggap"],
        dropFileHere: "I-drop ang iyong Excel file dito",
        supports: "Sumusuporta sa .xlsx at .xls — maximum 10 MB",
        chooseFileUpload: "Pumili ng File & I-upload",
        parsing: "Pinoproseso ang file...",
        invalidFileType: "Hindi valid na uri ng file. Mag-upload ng Excel file.",
        noData: "Walang data na natagpuan sa Excel",
        failedToRead: "Nabigo sa pagbasa ng Excel file",
        unableToRead: "Hindi mabasa ang file.",
        reviewTitle: "Suriin ang Warehouse Data",
        reviewSubtitle: "Huling pagsusuri bago i-import sa iyong negosyo.",
        changeFile: "Baguhin ang File",
        rowsFound: "mga row na natagpuan",
        cancel: "Kanselahin",
        finalizeImport: "Tapusin & I-import",
        importing: "Ini-import...",
        success: "Tagumpay",
        allWarehouseUploadedSuccess: "Matagumpay na na-upload ang lahat ng warehouse",
        failed: "Nabigo",
        bulkUploadFailed: "Nabigo ang bulk upload",
        error: "Error",
        binNamesNote: "Sa <strong>Bin Names</strong> column, ilagay ang lahat ng bin locations para sa isang warehouse sa isang cell, pinaghihiwalay ng comma — hal. A1, A2, B1, RACK-01.",
        headers: { warehouseName: "Pangalan ng Warehouse", email: "Email", phoneNumber: "Numero ng Telepono", location: "Lokasyon", binNames: "Mga Pangalan ng Bin" }
    },
    VariantTemplate: {
        VariantTemplates: "Mga Template ng Variant",
        Managereusablevariantpatterns: "Pamahalaan ang mga reusable na variant patterns",
        BinTransferHistory: "Kasaysayan ng Bin Transfer",
        Trackmovementsacrossbins: "Subaybayan ang mga galaw sa pagitan ng mga bin",
        SerialNumberHistory: "Kasaysayan ng Serial Number",
        Trackproductserialnumberactivity: "Subaybayan ang aktibidad ng serial number ng produkto",
        Period: "Panahon",
        Nohistoryfound: "Walang nakitang kasaysayan",
        Searchserialnumbers: "Maghanap ng serial numbers...",
        SerialNumbersHistory: "Kasaysayan ng Serial Numbers",
        Serialnumberhistoryglance: "Kasaysayan ng serial number sa isang sulyap.",
        Noserialnumbersfound: "Walang nakitang serial numbers",
        Noactivityhistoryfound: "Walang nakitang kasaysayan ng aktibidad",
        Statussetto: "Status na nakatakda sa",
        Timeline: "Timeline",
        Managereusableproductvariantpatterns: "Pamahalaan ang mga reusable na variant patterns ng produkto.",
        DeleteTemplate: "Tanggalin ang Template",
        Areyousureyouwanttemplate: "Sigurado ka bang gusto mong tanggalin ang template na ito?",
        CreateNewTemplate: "Gumawa ng Bagong Template",
        CreateTemplate: "Gumawa ng Template",
        EditTemplate: "I-edit ang Template",
        UnlimitedTemplates: "Walang limitasyong template",
        CreateAsManyTemplates: "Gumawa ng kahit ilang template na kailangan mo — Damit, Sapatos, Electronics atbp.",
        PickWhileAddingProduct: "Pumili habang nagdaragdag ng produkto",
        OpenTemplateLibrary: "Buksan ang iyong template library at pumili ng variant names sa ilang segundo.",
        MixFromMultipleTemplates: "Pagsamahin mula sa maraming template",
        SelectFromMultipleTemplates: "Pumili ng variant names mula sa higit sa isang template para sa isang produkto — lubos na flexible.",
        EditAnytime: "I-edit anumang oras",
        RenameTemplatesAnytime: "Palitan ang pangalan ng mga template, magdagdag o mag-alis ng variant names kapag nagbago ang catalog mo.",
        StayConsistent: "Manatiling consistent",
        SameVariantNamesAcrossAll: "Parehong variant names sa lahat ng produkto. Walang typo, walang duplicate, walang hula.",
        BuildOnceUseEverywhere: "Gumawa nang isang beses, gamitin kahit saan",
        StopReEnteringVariantNames: "Itigil ang paulit-ulit na paglalagay ng parehong variant names sa bawat produkto.",
        Updateexistingvariantcombinations: "I-update ang existing na variant combinations",
        Definenewvariantcombinations: "Magdefine ng bagong variant combinations",
        TemplateName: "Pangalan ng Template",
        AddVariantOptions: "Magdagdag ng Variant Options",
        SmallMedium: "hal. Small, Medium...",
        VariantsList: "Listahan ng Variants",
        Nooptionsaddedyet: "Wala pang naidagdag na opsyon",
        SaveTemplate: "I-save ang Template",
        egSizesColorsetc: "hal. Mga Sukat ng T-shirt, Kulay, atbp.",
        Pleaseentertemplatename: "Pakilagay ang pangalan ng template",
        Pleaseaddatleastonevariantoption: "Magdagdag ng kahit isang variant option",
        Templateupdatedsuccessfully: "Matagumpay na na-update ang template",
        Templatecreatedsuccessfully: "Matagumpay na nalikha ang template",
        Failedtosavetemplate: "Nabigo sa pag-save ng template",
        Transfer: "Ilipat",
        Editassignment: "I-edit ang assignment",
        Updateproductdetailsinbin: "I-update ang detalye ng produkto sa bin",
        Editinginbin: "Nagliliwanag sa bin",
        ConfirmUpdate: "Kumpirmahin ang Update",
        ConfirmAssign: "Kumpirmahin ang Assign",
        Assignanotherproduct: "Mag-assign ng ibang produkto",
        TransferBin: "Ilipat ang Bin",
        SourceBin: "Pinagmulan na Bin",
        DestinationBin: "Destinasyon na Bin",
        SelectSourceBin: "Piliin ang Pinagmulang Bin",
        SelectDestinationBin: "Piliin ang Destinasyong Bin",
        Unit: "Yunit",
        ManageVariant: "Pamahalaan ang Variant",
        CreateSKUvariationsyourproduct: "Gumawa ng SKU variations para sa iyong produkto",
        Assigningvariationsto: "Itinatalaga ang mga variation sa",
        Novariantsaddedyet: "Wala pang naidagdag na variant",
        AddedVariants: "Mga Naidagdag na Variant",
        AddVariantsfromTemplate: "Magdagdag ng Variant mula sa Template",
        Pickatemplateandselectvariantnames: "Pumili ng template at pumili ng variant names",
        ChooseaTemplate: "Pumili ng Template",
        Selectvariantnamestoadd: "Pumili ng variant names na idaragdag",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "Pumili ng template para pumili ng variant names. Pwede kang magdagdag mula sa marami.",
        Loadingtemplates: "Naglo-load ng mga template...",
        Backtotemplates: "Bumalik sa mga template",
        Selectallindividualadd: "Piliin lahat o indibidwal na variant names para idagdag.",
        VariantNames: "Mga Pangalan ng Variant",
        MediaDescription: "Media & Description",
        Addattachmentsandproductnotes: "Magdagdag ng mga attachment at product notes",
        ProductMedia: "Media ng Produkto"
    },
    AddProductGuide: {
        title: "Magdagdag ng initial quantity pagkatapos mag-save",
        description: "Walang quantity field ang mga produkto dito. Pagkatapos i-save, gamitin ang 'Stock In' para i-log ang iyong opening stock — na may buong kontrol sa lokasyon at tracking.",
        steps: {
            quantity: { title: "Quantity", sub: "Itakda ang opening stock count" },
            binLocation: { title: "Bin Location", sub: "Pasilyo, rack, shelf — hal. A-01-03" },
            serialNumbers: { title: "Serial Numbers", sub: "I-track ang bawat unit nang hiwalay" },
            warehouse: { title: "Warehouse", sub: "Saang lokasyon ito nakaimbak" },
            batchExpiry: { title: "Batch / Expiry", sub: "I-group ang stock ayon sa batch number" }
        },
        actions: { close: "Isara" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "Walang Nakitang Transfer Orders",
        Itemshistory: "Ang mga item na inililipat mo sa pagitan ng mga warehouse ay lilitaw dito para sa tracking at history.",
        CreateTransfer: "Gumawa ng Transfer"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "I-tap ang produkto para Mag-manufacture",
        Selectproductfrombelow: "Piliin ang produkto mula sa listahan sa ibaba",
        SetupANewProduct: "Mag-setup ng Bagong Produkto",
        DefineAProductAdditsrawmaterial: "Mag-define ng Produkto at idagdag ang mga raw material nito",
        ManufacturingSetup: "Setup ng Manufacturing",
        Pickproducttodefineitsproductiondetails: "Pumili ng produkto para i-define ang mga detalye ng produksyon nito",
        ConfigureManufacturing: "I-configure ang Manufacturing",
        SelectRawMaterial: "Pumili ng Raw Material",
        NoRawMaterials: "Walang mga Raw Material",
        Definecomponentsneededtoproduct: "I-define ang mga bahagi na kailangan para i-manufacture ang produktong ito.",
        NoAdditionalCosts: "Walang Karagdagang Gastos",
        Addlaboroverheadlogisticalcharges: "Magdagdag ng gastos sa paggawa, overhead, o logistical charges.",
        AddAdditionalCost: "Magdagdag ng Karagdagang Gastos",
        AddCost: "Magdagdag ng Gastos",
        TotalPrice: "Kabuuang Presyo",
        SelectCharges: "Pumili ng mga Charge",
        EnterEstimatedCost: "Ilagay ang Tinantyang Gastos",
        QtyRequried: "Kailangan na Qty",
        Manufacturing: "Manufacturing",
        Outputfinishedgoodsdestination: "Patutunguhan ng tapos na produkto",
        Manufacturingquantity: "Dami ng manufacturing",
        Storefinishedgoodsat: "I-imbak ang tapos na produkto sa",
        Rawmaterials: "Mga raw material",
        StockSelection: "Pagpili ng Stock",
        AdditionalCosts: "Mga Karagdagang Gastos",
        Quantityconsume: "Daming ginamit",
        Totalmanufacturingcost: "Kabuuang gastos sa manufacturing",
        Sumofrawmaterialcosts: "Kabuuan ng lahat ng gastos sa raw material",
        CustomManufacturingCharge: "Custom na Charge sa Manufacturing",
        Addextralikelaboroverheadrepairs: "Magdagdag ng mga extra tulad ng paggawa, overhead, o repair.",
        CalculatedTotal: "Kalkuladong Kabuuan",
        AddRawMaterial: "Magdagdag ng Raw Material",
        ConfigureRawMaterial: "I-configure ang Raw Material",
        Thisoutputunit: "Ito ang base quantity na kailangan bawat unit ng output.",
        ChangeProduct: "Palitan ang Produkto",
        AddtoList: "Idagdag sa Listahan",
        ManufacturedSuccessfully: "Matagumpay na Na-manufacture",
        Manufacture: "Pagmamanupaktura",
        EditDeleteHistory: "I-edit/I-delete ang Kasaysayan",
        ManageOrder: "Pamahalaan ang Order",
        ManageBatch: "Pamahalaan ang Batch",
        Paymentnotavailablehere: "Hindi available ang bayad dito",
        Thisrecordisanorderorderitself: "Ang record na ito ay mula sa isang order. Ang bayad ay maaari lamang i-record mula sa order mismo.",
        Torecorpaymenttheorderthethere: "Para mag-record ng bayad, pumunta sa naka-link order at gamitin ang opsyong <b>I-record ang Bayad</b> doon.",
        GotoOrder: "Pumunta sa Order"
    },
    CustomerExcel: {
        title: "I-upload ang mga Customer",
        description: "Sundin ang mga hakbang sa ibaba upang gumawa ng maraming customer gamit ang Excel file.",
        bulkUploadGuide: "Gabay sa Bulk Upload",
        step1: "Hakbang 1",
        downloadTemplate: "I-download ang Excel template",
        downloadTemplateDesc: "Kunin ang opisyal na template na may lahat ng kinakailangang column headers.",
        downloadTemplateBtn: "I-download ang Template",
        step2: "Hakbang 2",
        fillExcelFile: "Punan ang Excel file",
        fillExcelDesc: "Ang bawat row ay kumakatawan sa isang customer. Punan ang lahat ng column ayon sa kinakailangan.",
        step3: "Hakbang 3",
        thingsToKeepInMind: "Mga bagay na dapat tandaan",
        rulesDesc: "Bago i-upload, siguraduhing sumusunod ang iyong file sa mga patakarang ito upang maiwasan ang mga error.",
        step4: "Hakbang 4",
        uploadYourFile: "I-upload ang iyong file",
        uploadDesc: "Kapag napuno na, i-upload ang file sa ibaba. Awtomatikong gagawa ang system ng lahat ng customer.",
        rules: [
            "Isang row bawat customer lamang",
            "Huwag baguhin ang column header names",
            "Numero ng contact na may country code",
            "Tanging .xlsx o .xls files ang tinatanggap"
        ],
        dropFileHere: "I-drop ang iyong Excel file dito",
        supports: "Sumusuporta sa .xlsx at .xls — maximum 10 MB",
        chooseFileUpload: "Pumili ng File & I-upload",
        parsing: "Pinoproseso ang file...",
        invalidFileType: "Hindi valid na uri ng file. Mag-upload ng Excel file.",
        noData: "Walang data na natagpuan sa Excel",
        failedToRead: "Nabigo sa pagbasa ng Excel file",
        unableToRead: "Hindi mabasa ang file.",
        reviewTitle: "Suriin ang Customer Data",
        reviewSubtitle: "Huling pagsusuri bago i-import sa iyong negosyo.",
        changeFile: "Baguhin ang File",
        rowsFound: "mga row na natagpuan",
        cancel: "Kanselahin",
        finalizeImport: "Tapusin & I-import",
        importing: "Ini-import...",
        success: "Tagumpay",
        allCustomerUploadedSuccess: "Matagumpay na na-upload ang lahat ng customer",
        failed: "Nabigo",
        bulkUploadFailed: "Nabigo ang bulk upload",
        error: "Error",
        headers: {
            customerName: "Pangalan ng Customer",
            phoneNumber: "Contact",
            address: "Address",
            note: "Note"
        }
    },
    SupplierExcel: {
        title: "I-upload ang mga Vendor",
        description: "Sundin ang mga hakbang sa ibaba upang gumawa ng maraming vendor gamit ang Excel file.",
        bulkUploadGuide: "Gabay sa Bulk Upload",
        step1: "Hakbang 1",
        downloadTemplate: "I-download ang Excel template",
        downloadTemplateDesc: "Kunin ang opisyal na template na may lahat ng kinakailangang column headers.",
        downloadTemplateBtn: "I-download ang Template",
        step2: "Hakbang 2",
        fillExcelFile: "Punan ang Excel file",
        fillExcelDesc: "Ang bawat row ay kumakatawan sa isang vendor. Punan ang lahat ng column ayon sa kinakailangan.",
        step3: "Hakbang 3",
        thingsToKeepInMind: "Mga bagay na dapat tandaan",
        rulesDesc: "Bago i-upload, siguraduhing sumusunod ang iyong file sa mga patakarang ito upang maiwasan ang mga error.",
        step4: "Hakbang 4",
        uploadYourFile: "I-upload ang iyong file",
        uploadDesc: "Kapag napuno na, i-upload ang file sa ibaba. Awtomatikong gagawa ang system ng lahat ng vendor.",
        rules: [
            "Isang row bawat vendor lamang",
            "Huwag baguhin ang column header names",
            "Numero ng contact na may country code",
            "Tanging .xlsx o .xls files ang tinatanggap"
        ],
        dropFileHere: "I-drop ang iyong Excel file dito",
        supports: "Sumusuporta sa .xlsx at .xls — maximum 10 MB",
        chooseFileUpload: "Pumili ng File & I-upload",
        parsing: "Pinoproseso ang file...",
        invalidFileType: "Hindi valid na uri ng file. Mag-upload ng Excel file.",
        noData: "Walang data na natagpuan sa Excel",
        failedToRead: "Nabigo sa pagbasa ng Excel file",
        unableToRead: "Hindi mabasa ang file.",
        reviewTitle: "Suriin ang Vendor Data",
        reviewSubtitle: "Huling pagsusuri bago i-import sa iyong negosyo.",
        changeFile: "Baguhin ang File",
        rowsFound: "mga row na natagpuan",
        cancel: "Kanselahin",
        finalizeImport: "Tapusin & I-import",
        importing: "Ini-import...",
        success: "Tagumpay",
        allSupplierUploadedSuccess: "Matagumpay na na-upload ang lahat ng vendor",
        failed: "Nabigo",
        bulkUploadFailed: "Nabigo ang bulk upload",
        error: "Error",
        headers: {
            supplierName: "Pangalan ng Vendor",
            phoneNumber: "Contact",
            bankName: "Pangalan ng Bangko",
            accountHolderName: "Pangalan ng Account Holder",
            accountNumber: "Numero ng Account",
            note: "Note"
        }
    },
    ReplaceReturnLocal: {
        ReplacedWith: "Pinalitan ng",
        Noreplacementhistoryfound: "Walang nahanap na kasaysayan ng pagpapalit",
        Noreturnhistoryfound: "Walang nahanap na kasaysayan ng pagbabalik",
        Productbeingreturned: "Produkto na ibinabalik",
        Required: "Kinakailangan",
        Selectreturnedproduct: "Pumili ng ibinalik na produkto",
        Searchnamescanbarcode: "Maghanap sa pangalan, SKU o i-scan ang barcode",
        Browse: "Mag-browse",
        Stockhandling: "Paghawak ng stock-in",
        Stockinreturnedproduct: "I-stock-in ang ibinalik na produkto",
        Ontoinventory: "On — ang ibinalik na item ay idaragdag muli sa imbentaryo",
        Offreturnedonly: "Off — ang item ay itatala lamang bilang ibinalik",
        Usedrestock: "Ginagamit upang kalkulahin ang pagsasaayos ng tubo sa pag-restock",
        Willaddedbackconfirmation: "Idaragdag muli sa imbentaryo kapag nakumpirma na",
        Returnreason: "Dahilan ng pagbabalik",
        Optional: "Opsyonal",
        SelectReason: "Pumili ng Dahilan",
        Additionalnotes: "Karagdagang mga tala",
        Describeofcustomerexplanation: "Ilarawan ang kondisyon ng ibinalik na item, anumang nakikitang pinsala, paliwanag ng customer...",
        Requiredmustfilledcontinue: "Dapat punan ang mga kinakailangang field upang magpatuloy",
        Reviewdetailsbeforeconfirming: "Suriin ang mga detalye bago kumpirmahin",
        Replacementproductwilldeductedinventoryconfirmation: "Ang pamalit na produkto ay ibabawas mula sa iyong imbentaryo kapag nakumpirma na.",
        Choosereplacementproduct: "Pumili ng pamalit na produkto",
        Willdeductedfrominventoryconfirm: "Ibabawas mula sa imbentaryo kapag nakumpirma na",
        Thesewillattachedothereturnrecord: "Ang mga larawang ito ay ilalakip sa talaan ng pagbabalik",
        Replacementitem: "Item na pamalit",
        Addanotherproduct: "Magdagdag ng isa pang produkto",
        Replacementproductwillbe: "Ang pamalit na produkto ay",
        deducted: "ibabawas",
        fromyourinventoryconfirmation: "mula sa iyong imbentaryo kapag nakumpirma na.",
        productadjustedusingprice: "Ang ibinalik na produkto ay ire-restock at ang tubo ay isasaayos gamit ang orihinal na presyo ng pagbebenta.",
        Willloggedreturnedonlynotrestocked: "Itatala lamang bilang ibinalik — hindi ire-restock",
        Returnonly: "Pagbabalik lamang",
        Imagesofreturnedproduct: "Mga larawan ng ibinalik na produkto",
        Returnedproductwill: "Ang ibinalik na produkto ay",
        not: "hindi",
        berestockedloggedreturnedonly: "ire-restock — itatala lamang bilang ibinalik.",
        AddImage: "Magdagdag ng Larawan",
        STOCKIN: "STOCK IN",
        LOGONLY: "I-LOG LAMANG",
        ContinuetoReview: "Magpatuloy sa Pagsusuri →",
        Confirmreplacement: "Kumpirmahin ang pagpapalit",
        Confirmreturn: "Kumpirmahin ang pagbabalik",
        Filldetailsbelowproceed: "Punan ang mga detalye sa ibaba upang magpatuloy",
        Review: "Pagsusuri",
        editdetails: "i-edit ang mga detalye",
        Configurereturndetails: "I-configure ang mga detalye ng pagbabalik",
        Configurereplacementdetails: "I-configure ang mga detalye ng pagpapalit",
        SelectSource: "Pumili ng Pinagmulan",
        Returning: "Nagbabalik",
        Replacement: "Pagpapalit",
        WalkCustomer: "Walk-in na Customer",
        RETURNEDPRODUCT: "IBINALIK NA PRODUKTO",
        REPLACEMENTPRODUCT: "PAMALIT NA PRODUKTO",
        STOCKOUT: "STOCK OUT",
        Netinventoryimpact: "Netong epekto sa imbentaryo",
        Replacementitemcost: "Gastos ng pamalit na item",
        Returneditemrestockvalue: "Halaga ng pag-restock ng ibinalik na item",
        PROFITINVENTORYSUMMARY: "BUOD NG TUBO AT IMBENTARYO",
        Inventoryaction: "Aksyon sa imbentaryo",
        Valuededucted: "Halagang ibinawas",
        Profitadjustment: "Pagsasaayos ng tubo",
        stockedout: " na-stock out",
        restocked: " na-restock",
        Noaction: "Walang aksyon",
        Valuebeingreturned: "Halagang ibinabalik",
        Willberestocked: "Ire-restock",
        Willbe: "Maging",
        logged: "na-log",
        ON: "BUKAS",
        OFF: "SARADO",
        Linked: "Linked",
        Pleaseselectreturnedproduct: "Mangyaring pumili ng isang produktong ibinalik",
        Quantityrequired: "Kailangan ang dami",
        Buyingpricerequired: "Kailangan ang presyo ng pagbili",
        Pleaseaddleastreplacementproduct: "Mangyaring magdagdag ng kahit isang replacement product",
        Pleaseconfigurereturnedproductdetails: "Mangyaring i-configure ang mga detalye ng ibinalik na produkto",
        Pleaseselectcustomer: "Mangyaring pumili ng customer",
        Returndateisrequired: "Kailangan ang petsa ng pagbabalik",
        Pleasefillallrequiredfields: "Mangyaring punan ang lahat ng kinakailangang fields",
        Wildeductedfrominventory: "Ibabawas sa imbentaryo",
        Currentprice: "Kasalukuyang presyo",
        Defectivedamaged: "Depektibo / nasira",
        Wrongitemreceived: "Maling item ang natanggap",
        Customerchangedmind: "Nagbago ng isip ang customer",
        Sizefitissue: "Problema sa sukat / pagkakaayon",
        Notasdescribed: "Hindi ayon sa paglalarawan",
        Other: "Iba pa",
        Originalsaleprice: "Orihinal na presyo ng benta (profit adj.)",
        Addedbackinventory: "Idinagdag pabalik sa imbentaryo",
        Notaddedinventory: "Hindi idinagdag sa imbentaryo",
        replacedwith: "pinalitan ng",
        deductedfrominventory: "ibinawas sa imbentaryo",
        RETURNWITHSTOCKIN: "RETURN · WITH STOCK-IN",
        RETURNNOSTOCKIN: "RETURN · NO STOCK-IN",
        MULTIPLEREPLACEMENTS: "MARIPLING PAGPAPALIT",
        SINGLEREPLACEMENT: "ISANG PAGPAPALIT",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "IBINALIK · STOCK IN",
        REPLACEMENTSTOCKOUT: "PAGPAPALIT · STOCK OUT",
        Returnonlylogsthisentry: "Return only logs this entry —",
        nostockwillbeaddedorremoved: "no stock will be added or removed",
        frominventory: "from inventory.",
        Whentousethis: "When to use this:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "Use Return at end of day to record items sent out for sales that came back damaged or unusable — items you want to track but cannot add back to inventory.",
        Youcanviewallpastreturnentriesin: "You can view all past return entries in",
        ReturnHistory: "Return History",
        underthe: "under the",
        Others: "Others",
        tab: "tab.",
        Negativestocktransactiondisabled: "Ang mga negatibong transaksyon sa stock ay hindi pinagana."
    },
    NewRLocal: {
        Originalsaleprice: "Orihinal na presyo ng benta",
        Editinghistoryonlyinventorystaysunchanged: "I-e-edit lamang ang history — ang imbentaryo ay mananatiling walang pagbabago.",
        Changeshereupdatethisdetailsquantitiesaffected: "Ang mga pagbabago rito ay mag-a-update lamang sa mga detalye ng record na ito (dahilan, petsa, mga tala). Ang iyong aktwal na dami ng stock, mga lokasyon ng bin, at data ng produkto ay hindi maaapektuhan.",
        Needtofixinventorylevelsinstead: "Kailangan bang ayusin ang mga antas ng imbentaryo sa halip?",
        AdjustStock: "I-adjust ang Stock",
        Refund: "Refund",
        ImportantNote: "Mahalagang Paalala",
        Pleasereviewbeforecontinuing: "Mangyaring suriin bago magpatuloy",
        Onceshippedreceivedanyupdatesmadeorder: "Kapag ang isang order ay naipadala o natanggap na, ang anumang mga update na ginawa sa order ay hindi makikita sa kasaysayan ng transaksyon.",
        Thisundone: "Permanente nitong aalisin ang order. Ang aksyong ito ay hindi na mababawi.",
        Inventorywilladjustedautomatically: "Ang imbentaryo ay hindi awtomatikong ia-adjust",
        Deletingthisreversevedshippedyouwillneed: "Ang pagbura nito ay hindi nagpapawalang-bisa sa anumang pagbabago sa stock. Kung ang mga item ay natanggap/naipadala na, kakailanganin mong",
        reflectthecorrectstocklevels: "upang ipakita ang tamang antas ng stock.",
        manuallyadjustyourinventory: "manu-manong i-adjust ang iyong imbentaryo",
        Addremovestockforitemsthatwereshipped: "Magdagdag/mag-alis ng stock para sa mga item na naipadala",
        Addremovestockforitemsthatwerereceived: "Magdagdag/mag-alis ng stock para sa mga item na natanggap",
        Updatecostrecordspaymentwaalreadymade: "I-update ang mga record ng gastos kung ang pagbabayad ay nagawa na",
        Reconcilerecordsandoutstandingpayments: "I-reconcile ang mga record at mga hindi pa bayad na halaga"
    },
    ReceivablesLocal: {
        Receivables: "Mga Natatanggap",
        Manageandtrackcustomerduebalances: "Pamahalaan at subaybayan ang mga balanse ng customer na dapat bayaran",
        Viewcustomerduebalancereport: "Tingnan ang ulat ng balanse ng customer",
        Viewsupplierduebalancereport: "Tingnan ang ulat ng balanse ng supplier",
        DueBalance: "Balanseng Dapat Bayaran",
        Unpaid: "Hindi Pa Nababayaran",
        PartiallyPaid: "Bahagyang Nabayaran",
        Paid: "Nabayaran Na",
        HighestBalance: "Pinakamataas na Balanse",
        LowestBalance: "Pinakamababang Balanse",
        Filldetailsrecordpayment: "Punuan ang mga detalye upang i-record ang bayad",
        NewPaymentEntry: "Bagong Entry sa Pagbabayad",
        EditPaymentEntry: "I-edit ang Entry sa Pagbabayad",
        Nosuppliersfound: "Walang nakitang supplier",
        Nocustomersfound: "Walang nakitang customer",
        LowtoHigh: 'Mababa pataas',
        HightoLow: 'Mataas pababa',
        AttachmentUploadedSc: "Matagumpay na na-upload ang attachment",
        AttachmentUploadedF: "Nabigo sa pag-upload ng attachment",
        Pay: "Bayaran",
        NoBillsFound: "Walang Nakitang Bill",
        Thiscustomerhasunpaidbills: "Walang hindi pa nababayaran na bill ang customer na ito.",
        TotalDue: "Kabuuang Dapat Bayaran",
        BillsFound: "Nakitang Bill",
        DeselectAll: "Alisin ang lahat ng marka",
        SelectAll: "Piliin Lahat",
        ShowDetails: "Ipakita ang mga Detalye"
    },
    AssetsNewLocal: {
        Assignedon: "Itinalaga noong",
        Total: "Kabuuan",
        Assigned: "Itinalaga",
        Remaining: "Natitira",
        Available: "Magagamit",
        NoSerialNumbers: "Walang serial number",
        UpdateExistingAssetDetails: "I-update ang mga detalye ng umiiral na asset",
        RegisterNewBusinessAsset: "Magrehistro ng bagong asset ng negosyo",
        BasicInformation: "Pangunahing Impormasyon",
        AssetDetails: "Mga Detalye ng Asset",
        Quantity: "Dami",
        SerialNumbers: "Mga Serial Number",
        SerialNumberPlaceholder: "Serial number",
        AddSerialNumber: "Magdagdag ng Serial Number",
        SerialNumbersOptional: "Opsyonal ang mga serial number. Maaari kang magdagdag ng hanggang",
        AssetImages: "Mga Larawan ng Asset",
        AdditionalNotes: "Mga Karagdagang Tala",
        AdditionalNotesPlaceholder: "Anumang karagdagang detalye o kasaysayan ng pagpapanatili...",
        Updating: "Nag-a-update...",
        Adding: "Nagdaragdag...",
        ITEquipmentPlaceholder: "hal. Kagamitang IT",
        LoadingMoreActivities: "Naglo-load ng higit pang mga aktibidad...",
        AssignedAssets: "Mga Na-assign na Asset",
        Noassetsassignedstaffmember: "Walang asset na na-assign sa staff member na ito.",
        Assignassetstaff: "Mag-assign ng asset sa staff",
        Returnassetfromstaff: "Ibalik ang asset na ito mula sa staff",
        AssignmentDetails: "Mga Detalye ng Pag-assign",
        Serial: "Serial",
        ViewAssets: "Tingnan Lahat ng Asset",
        ViewByStaff: "Tingnan ayon sa Staff",
        AssignedHistory: "Kasaysayan ng Pag-assign",
        Returned: "Nabalik",
        Returnedon: "Nabalik noong",
        ReturnedBy: "Nibalik ni",
        AssignedTo: "Na-assign kay",
        NoHistoryRecords: "Walang rekord ng kasaysayan",
        Selectstaffmemberviewtheirassets: "Pumili ng staff member upang tingnan ang kanilang mga asset.",
        Deleted: "TINANGGAL",
        searchPlaceholder: "Maghanap ng asset ayon sa pangalan o serial number..."
    },
    InventoryCountLocale: {
        InventoryCount: "Pagbilang ng Imbentaryo",
        Viewinventorycountreport: "Tingnan ang ulat ng pagbilang ng imbentaryo",
        ItemsCount: "Bilang ng mga Item",
        All: "Lahat",
        InProgress: "Isinasagawa",
        Submitted: "Isinumite",
        awaitingreview: "Naghihintay ng Review",
        EditInventoryCount: "I-edit ang Pagbilang ng Imbentaryo",
        NewInventoryCount: "Bagong Pagbilang ng Imbentaryo",
        Modifyinventorycountsheetdetails: "Baguhin ang mga detalye ng sheet ng pagbilang",
        Startanewinventorycountsheet: "Magsimula ng bagong sheet ng pagbilang",
        GeneralInformation: "Pangkalahatang Impormasyon",
        Title: "Pamagat",
        SaveChanges: "I-save ang mga Pagbabago",
        Selectproductsforthisinventorycountsheet: "Pumili ng mga produkto para sa sheet na ito",
        InventoryCountDetails: "Mga Detalye ng Pagbilang",
        Inventorycountsheetdetails: "Mga detalye ng sheet ng pagbilang",
        Viewingdetailsforcountsheet: "Tinitingnan ang mga detalye ng count sheet",
        Started: "Sinimulan",
        TaskSheets: "Mga Task Sheet",
        Allitems: "Lahat ng item",
        NotStarted: "Hindi pa sinisimulan",
        Completed: "Nakumpleto",
        Results: "Mga Resulta",
        ViewResults: "Tingnan ang mga Resulta",
        DeleteInventoryCount: "Tanggalin ang Pagbilang ng Imbentaryo",
        Viewingtransactionandadjustments: "Tinitingnan ang transaction logs at stock adjustments",
        Productsadjusted: "Mga produktong inayos",
        Assignee: "Itinalaga kay",
        Tasksheetdetails: "Mga detalye ng task sheet",
        Draft: "Draft",
        VariantQuantities: "Mga Quantity ng Variant",
        AssignedProducts: "Mga Na-assign na Produkto",
        ReturnAsset: "Ibalik ang Asset",
        EditTasksheet: "I-edit ang Task Sheet",
        NewTasksheet: "Bagong Task Sheet",
        Updatetasksheetdetails: "I-update ang mga detalye ng task sheet",
        Starttasksheetforthisinventorycount: "Magsimula ng bagong task sheet para sa count na ito",
        TaskSheetInformation: "Impormasyon ng Task Sheet",
        SheetTitle: "Pamagat ng Sheet",
        Entersheettitle: "Ilagay ang pamagat ng sheet",
        SubmissionResult: "Resulta ng Pagsusumite",
        ReviewChanges: "Suriin ang mga Pagbabago",
        Viewingsubmissionresultsforthisinventorycount: "Tinitingnan ang resulta ng pagsusumite para sa count na ito",
        Reviewyourinventorycountbeforesubmitting: "Suriin ang iyong inventory count bago isumite"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "Nabigo sa pag-load ng counts",
        NoInventoryCounts: "Walang Inventory Counts",
        NoMatches: "Walang Tugma",
        Therearenoinventorycountswiththestatus: "Walang inventory counts na may status na",
        Noinventorycountsfoundyoursearchterm: "Walang nahanap na inventory counts na tumutugma sa iyong search term.",
        Thereareinventorycountsrecordedyetforthisbusiness: "Wala pang naitalang inventory counts para sa negosyong ito."
    },
    StockinModalP: {
        StockInNow: "Stock In Ngayon",
        Settheopeningquantityforthisproductrightnow: "Itakda ang opening quantity para sa produktong ito ngayon.",
        Addinitialstock: "Magdagdag ng initial stock?",
        dothislater: "Gagawin ko ito mamaya",
        Productadded: "Matagumpay na naidagdag ang produkto!",
        isready: "handa na.",
        SeeHowItWorks: "Tingnan Kung Paano Ito Gumagana",
        NoSalesOrdersFound: "Walang Sales Orders Na Natagpuan",
        NoPurchaseOrdersFound: "Walang Purchase Orders Na Natagpuan",
        Startcreatingoutgoinginventoryrevenue: "Simulan ang paglikha ng sales orders upang subaybayan ang iyong outgoing inventory at kita.",
        Trackrestockssupplierplace: "Subaybayan ang iyong inventory restocks at supplier orders sa isang lugar.",
        CreateSalesOrder: "Gumawa ng Sales Order",
        CreatePurchaseOrder: "Gumawa ng Purchase Order",
    }
    ,
    dialy_report: "Daily Movement Report",
    Quotation: "Quote",
    Quote: "Quote",
    Assignee: "Itinalaga kay",
    dayStart: "Simula ng araw",

    ShowTotalAmount: "Kabuuang Halaga",


    tutorial: {
        watchTitle: 'Manood ng mga sunud-sunod na tutorial',
        watchDesc: 'Matuto tungkol sa SimplyStock sa aming YouTube channel',
        modalTitle: 'Manatiling nangunguna sa SimplyStock',
        modalDesc: 'Mag-subscribe para makakuha ng mga bagong tutorial sa oras na lumabas ang mga ito',
        feature1Title: 'Mga walkthrough ng bagong tampok',
        feature1Sub: 'Ipinapaliwanag ang bawat bagong update gamit ang isang maikling video — para hindi mo makaligtaan ang mga bago',
        feature2Title: 'Mabilisang mga video kung paano gawin',
        feature2Sub: 'Mag-set up ng stock, mga invoice, access sa staff at higit pa sa loob ng wala pang 5 minuto',
        feature3Title: 'Mga agarang abiso',
        feature3Sub: 'Maabisuhan sa sandaling may bagong tutorial na lumabas — matuto sa sarili mong bilis',
        feature4Title: '100% libre, palagi',
        feature4Sub: 'Libre ang lahat ng tutorial magpakailanman — hindi kailangan ng login o subscription',
        subscribeBtn: 'Mag-subscribe sa SimplyStock',
        maybeLater: 'Maaaring mamaya'
    }
    ,
    dailyCashReport: {
        "title": "Araw-araw na Cash Report",
        "subtitle": "Sino ang nagbayad, kailan, at ano ang utang pa — mula sa Sales Detail.",
        "totalSales": "Kabuuang Benta",
        "cashReceived": "Kabuuang Natanggap",
        "outstanding": "Natitirang Utang",
        "collectionRate": "Rate ng Koleksyon",
        "grandTotalAllDates": "KABUUANG KABUUAN (lahat ng petsa)",
        "totalLabel": "Kabuuan",
        "loading": "Naglo-load...",
        "noData": "Walang nakitang data sa napiling saklaw ng petsa.",
        "loadingMore": "Naglo-load pa..."
    },
    dailyCashReportColumns: {
        "date": "Petsa",
        "customer": "Customer",
        "productsSold": "Nabentang Produkto",
        "products": "Produkto",
        "salesAmount": "Halaga ng Benta",
        "sales": "Benta",
        "received": "Kabuuang Natanggap",
        "receivedShort": "Natanggap",
        "debited": "Na-debit sa Ledger",
        "due": "Utang",
        "paymentModes": "Paraan ng Pagbabayad",
        "mode": "Paraan"
    }
}

export default tl
